import { screenCopyZh } from "./zh-HK-screens";
export const zhHK = {
  automaticBackup: {
    leaveShort: "離開前備份",
    leaveHint: "離開課序前，請按「立即備份」，確認顯示「此裝置的改動已完成備份」後才離開。自動備份作補充保障。",
    title: "備份記錄",
    unlockNeeded: "此裝置尚未解鎖備份",
    errorSync: "其他裝置已有較新的完整備份，請讓此裝置完成同步後再備份或讀取。",
    errorOverdue: "有新資料超過 24 小時未完成備份，請檢查網絡和 Drive 連接。",
    errorLimit: "完整備份超過目前的 100 MB 上限，請先下載手動加密備份並聯絡支援。",
    close: "關閉備份記錄",
    setup: "啟用自動備份",
    password: "復原密碼",
    confirmPassword: "再次輸入復原密碼",
    passwordHint: "至少 8 個字元。請另行保存；所有裝置及密碼都遺失後，課序無法代為解密。日常不用再輸入。",
    trust: "這是私人裝置，同意記住金鑰及以下清理規則",
    retention:
      "三部裝置共用最新 4 份成功完整備份，不另保留每日版本。舊的自動備份會永久刪除；尚未合併的資料及還原前返回點會額外保護。",
    mismatch: "兩次輸入的復原密碼不一致。",
    unlock: "解鎖此裝置",
    unlockHint: "輸入一次復原密碼，這部私人裝置日常便毋須再輸入。",
    enabled: "自動備份已開啟",
    disabled: "自動備份已關閉",
    disable: "關閉自動備份",
    enable: "開啟自動備份",
    resume: "完成首次備份",
    now: "立即備份",
    refresh: "重新檢查",
    checking: "檢查備份中",
    working: "正在處理備份",
    pending: "有改動等待完整備份",
    saved: "此裝置的改動已完成備份",
    unavailable: "備份暫未完成，程式會自動重試。",
    lastSuccess: "最後成功備份",
    lastCheck: "最近完成檢查",
    pendingSince: "待備份起點",
    none: "尚未有紀錄",
    covered: "資料時間",
    completed: "完成時間",
    source: "來源裝置",
    latest: "最新",
    recent: "最近",
    daily: "每日",
    protected: "還原前保護",
    branch: "保留版本",
    inspect: "查看",
    restore: "讀取",
    details: "備份內容",
    classes: "班別",
    records: "紀錄數",
    empty: "首份完整備份完成後會顯示在這裡。",
    restoreConfirm:
      "讀取 {{time}} 的備份？程式會先保存目前資料的返回點，再取代此工作區資料；還原結果會同步至其他已連接裝置。尚未同步的不同改動會保留並可能需要處理衝突。",
    recoveryConfirm:
      "在這部新裝置讀取 {{time}} 的備份？程式會先保護本機資料，再重新建立工作區同步連結。舊裝置的本機及雲端歷史會保留；舊裝置之後需要重新連接。",
    restored: "資料已還原。重新開啟工作台以繼續使用。",
    reopen: "重新開啟工作台",
    resumeRecovery: "完成復原連線",
    drive: "備份 Google Drive",
    connect: "連接 Google Drive",
    openGoogle: "開啟 Google 授權",
    confirmDrive: "使用這個 Drive 帳戶",
    wrongDrive: "請連接原本存放備份的 Drive 帳戶。",
    errorPassword: "復原密碼不正確，或復原金鑰資料已損壞。",
    errorSetupPassword: "請輸入第一次設定時使用的復原密碼；重試不會更改密碼。",
    errorRecentLogin: "此裝置尚未獲授權。請先完成裝置同步配對，或保存資料後重新登入同一課序帳戶，再啟用備份。",
    errorDraft: "請先完成目前的保存或處理未保存資料，再讀取備份。",
    errorChanged: "保護副本製作期間資料已更新；現有資料未被取代，請重新讀取。",
    errorQuota: "Drive 空間不足，請釋放空間後重試。既有備份仍保留。",
    errorAuth: "請重新連接原本的 Google Drive 帳戶。",
    errorDevice: "此裝置需要重新授權，才能存取備份。",
    errorFormat: "備份驗證未通過，已停止讀取或清理。",
    errorService: "此環境的自動備份服務尚未可用。",
    errorGeneric: "未能完成操作，請重試。已有備份仍保留。",
    overdue: "有新資料超過 24 小時尚未完成備份。",
    dismiss: "知道了",
    readOnly: "查看不會改動目前資料。",
    encrypted: "上傳前加密",
    connectionRequired: "需要連線後才能查看或讀取雲端備份。",
  },
  schoolCalendar: {
    manage: "校曆設定",
    editMarker: "修改",
    delete: "刪除",
    eventsList: "事項列表",
    title: "全校校曆",
    tools: "常用標記",
    edit: "編輯校曆",
    save: "保存校曆",
    saved: "已保存",
    editing: "編輯中",
    unsaved: "未保存",
    saving: "保存中",
    cancel: "取消",
    undo: "撤銷上次修改",
    name: "標記名稱",
    arrangement: "課堂安排",
    scope: "適用範圍",
    schoolWide: "全校",
    note: "備註",
    kinds: {
      publicHoliday: "公眾假期",
      schoolHoliday: "學校假期",
      teacherDevelopment: "教師發展日",
      exam: "考試／對卷",
      activity: "學生活動",
      parentsDay: "家長日",
      specialClass: "特別上課",
      specialDay: "其他事項",
    },
    short: {
      publicHoliday: "休",
      schoolHoliday: "假",
      teacherDevelopment: "師",
      exam: "考",
      activity: "活",
      parentsDay: "家",
      specialClass: "調",
      specialDay: "記",
    },
    arrangements: { normal: "照常上課", noClasses: "停課", special: "特別安排" },
    period: "9月至翌年8月",
    dates: "全年日期",
    chooseDates: "選取日期",
    chooseEnd: "已選 1 日 · 可選結束日期",
    selected: "已選 {{count}} 日",
    selected_one: "已選 {{count}} 日",
    selected_other: "已選 {{count}} 日",
    dateButton: "{{date}}，{{events}}",
    noEvents: "沒有事項",
    zoomMonth: "放大 {{month}}",
    backToYear: "返回全年",
    clear: "清除選取",
    inspect: "查看事項",
    apply: "套用標記",
    update: "更新標記",
    selection: "已選日期",
    dayItems: "{{date}} 的事項",
    close: "關閉日期事項",
    editItem: "修改 {{name}}",
    deleteItem: "刪除 {{name}}",
    add: "新增標記",
    official: "系統日子",
    eventCount: "{{count}} 項事項",
    eventCount_one: "{{count}} 項事項",
    eventCount_other: "{{count}} 項事項",
    conflict: "事項已在另一個分頁更新。請取消編輯後重新修改。",
    saveError: "未能保存校曆，修改仍保留在畫面中。",
    invalid: "請核對校曆事項的名稱及日期。",
    archived: "此學年已封存",
    leaveUnsaved: "校曆尚未保存，要放棄修改嗎？",
    range: "{{start}}–{{end}}",
    more: "+{{count}}",
    readOnly: "唯讀",
  },
  reportLabels: {
    removedStudent: "已移除學生",
    classNumberAndName: "班號及姓名",
    answerCount: "回答次數",
    dueDate: "到期日",
    homeworkSubmissionRecords: "交功課記錄",
    exceptionTask: "例外事項",
    currentRoles: "目前分工",
    roleHistory: "分工記錄",
    school: "學校",
    assessment: "評估",
    source: "來源",
    quizSessions: "小測場次",
    createdAt: "開設時間",
    quiz: "小測",
    code: "代碼",
    responseScores: "作答成績",
    submittedAt: "提交時間",
    noSavedRecords: "沒有已儲存紀錄",
    thisBrowserDoesNotSupportThePDFCanvas: "瀏覽器不支援 PDF 畫布",
  },
  interfaceExtras: {
    homework: "功課",
    assessment: "測驗",
    dictation: "默書",
    revision: "溫習",
    materials: "帶備物品",
    replySlip: "回條",
    exercise: "作業",
    worksheet: "工作紙",
    notes: "筆記",
    classwork: "堂課",
    revisionDictation: "溫習／默書",
    other: "其他",
    bug: "功能問題",
    idea: "功能建議",
    usability: "操作體驗",
    attendanceSummary: "{{absent}} 人缺席 · {{late}} 人遲到",
    studentCount: "{{count}} 人",
    studentCount_one: "{{count}} 人",
    studentCount_other: "{{count}} 人",
    missingLabel: "欠交",
    missingToggle: "欠交，按下取消",
    completeToggle: "已交，按下記作欠交",
    groupCount: "{{count}} 組",
    groupCount_one: "{{count}} 組",
    groupCount_other: "{{count}} 組",
    groupNumber: "第 {{number}} 組",
    or: "或",
    subject: "科目",
    duty: "職務",
    calendarFile: "校曆檔案",
    genderSuffix: "，{{gender}}生",
    widen: "加闊",
    cancelWiden: "取消加闊",
    publicHolidayDate: "，公眾假期紅日",
    noteSuffix: "，備註：{{note}}",
    subjectPrefix: "{{subject}}的",
    unknownError: "未知錯誤",
    attendanceStatus: "出勤狀態",
    materialsStatus: "欠帶書簿狀態",
  },
  screenCopy: screenCopyZh,
  language: {
    choose: "介面語言",
  },
  syncReview: {
    loadingClassroom: "正在載入課序…",
    inviteTitle: "Google Drive 同步",
    crossDeviceLabel: "跨裝置同步",
    closeSettings: "關閉同步設定",
    setupProgress: "同步設定進度",
    deviceStep: "記住裝置",
    googleStep: "授權 Drive",
    confirmStep: "確認連接",
    firstDeviceTitle: "先連接這部裝置",
    authorizeDriveTitle: "連接你的 Google Drive",
    returnAfterGoogle: "完成 Google 授權後，返回這裏按「重新檢查授權」。",
    connectedTitle: "已連接 Google Drive",
    manageDrive: "Google 授權設定",
    backToClassroom: "返回課序",
    optionalStep: "可選設定",
    offerTitle: "要在電腦和 iPad 接續使用嗎？",
    offerDescription: "開啟 Google Drive 同步，在另一部裝置也能接續班別及課堂記錄。",
    offerEnable: "設定跨裝置同步",
    offerLater: "稍後設定",
    offerLaterHint: "之後可隨時從頁首的同步設定開啟。",
    setupInProgress: "另一個分頁正在啟用同步，裝置資料已保留。請關閉其他課序分頁，再重新載入這頁繼續。",
    auditTitle: "同步 SQL 核對",
    auditHint:
      "只核對已啟用的課堂資料。先等兩端完成同步；檔案相同仍須配合新增、修改及刪除測試。核對檔為明文，只用虛構資料。",
    auditCapture: "製作 SQL 核對檔",
    auditBuild: "程式版本",
    auditRecords: "課堂記錄數",
    auditDownloadSql: "下載 SQL",
    auditDownloadReport: "下載核對報告",
    auditEmpty: "沒有課堂記錄，不能以空資料完成核對。",
    auditChanged: "製作期間有同步改動，請等保存及同步完成後重試。",
    auditNotReady: "請先連接同步，並處理待送、隔離或衝突項目後重試。",
    closeAuthorizationPage: "關閉授權完成頁",
    notEnabled: "尚未啟用同步",
    pairRequired: "需要配對此裝置",
    automaticSetupHint: "在自己的裝置啟用，現有課序資料會保留。之後用同一課序帳戶登入另一部裝置，掃 QR 配對一次。",
    enableDriveSync: "啟用 Google Drive 同步",
    continueSetup: "繼續啟用同步",
    existingPairedRoot: "這個帳戶已有同步，請用另一部已連接的裝置配對。",
    checkPairDevice: "確認以下是你要加入的裝置，再按「批准配對」。",
    approvePairOnce: "批准配對",
    pairOptionsTitle: "選擇這部裝置的配對方式",
    pairOptionsHint: "兩部裝置都登入同一課序帳戶，一部顯示 QR，另一部掃描。",
    pairShowHint: "讓另一部裝置用相機掃描此碼。",
    pairScanOptionHint: "用這部裝置的相機掃描另一部的配對碼。",
    pairStepsLabel: "裝置配對步驟",
    pairStepScan: "掃描 QR",
    pairStepApprove: "原裝置批准",
    pairStepDownload: "下載資料",
    pairShowTitle: "用另一部裝置掃描此碼",
    pairWaitingTitle: "等待原裝置批准",
    pairWaitingHint: "請保持此頁開啟，批准後會顯示下載按鈕。",
    pairApproveTitle: "核對要加入的裝置",
    pairApproveHint: "只批准你正在使用的私人裝置。",
    pairApprovedTitle: "已批准配對",
    pairApprovedHint: "接下來在新裝置下載資料；這部裝置請保持課序開著並連網。",
    pairDownloadTitle: "下載這份同步資料",
    pairDownloadHint: "完成後，開啟原有班別並核對最近的記錄。",
    pairRefreshQr: "重新產生 QR",
    pairAnotherDevice: "配對另一部裝置",
    pairBackToOptions: "返回配對方式",
    pairCameraTitle: "將另一部裝置的 QR 放入框內",
    pairCameraHint: "辨識後會自動讀取，毋須拍照。",
    pairCameraPermission: "如瀏覽器詢問相機權限，請選「允許」。",
    connectPairedDevice: "下載並連接現有同步",
    pairLocalDataRetained:
      "這部裝置已有本機資料，已保留，暫未連接雲端。兩份既有資料不會自動合併；請先在原有裝置繼續使用，聯絡支援安排轉移。",
    connectDriveNext: "裝置已準備好，下一步授權 Google Drive。",
    driveAuthorizationComplete: "Google 授權已完成。請回到原來的課序分頁，按「重新檢查授權」，核對 Drive 帳戶後連接。",
    differentDriveRetained: "這次選取的 Drive 與原有綁定不同，尚未切換。請重新授權原有 Drive。",
    syncUsage: "同步使用說明",
    syncUsageSteps:
      "首次啟用後授權 Google Drive；其他私人裝置掃 QR 配對一次。日常開啟課序並連網便會自動同步。換裝置前，先等「本機已保存」及「此裝置已同步」，再在另一端確認改動已收到。",
    rememberedDeviceLoss:
      "請保留至少一部已配對裝置及其網站資料。如果所有已配對裝置的網站資料都被刪除，單靠 Google 登入不能取回雲端加密資料；請勿清除網站資料或使用私密瀏覽。",
    setupReauthentication:
      "首次啟用需要近期登入。請保存資料後重新登入同一課序帳戶，再繼續啟用；不用 Touch ID 或密碼金鑰。",
    title: "跨裝置同步（開發測試）",
    intro: "只用虛構資料。這個入口使用獨立測試資料庫；公開同步仍未開放。",
    settings: "同步設定",
    saved: "本機已保存",
    saving: "正在保存本機修改",
    pending: "待同步",
    synced: "此裝置已同步",
    concurrentEditing: "請只在一部裝置修改",
    concurrentEditingHint:
      "偵測到已連接裝置有重疊改動。請先停止在另一部裝置修改；切換裝置前，等待「此裝置已同步」，並確認另一部已收到最新資料。",
    concurrentEditingDismiss: "知道了",
    reconnect: "需要重新連接",
    locked: "未解鎖",
    conflict: "有版本需要選擇",
    checking: "正在檢查同步",
    noBackground: "關閉瀏覽器或裝置休眠期間，不保證持續同步。",
    privateDevice: "記住此私人裝置",
    privateHint: "共用裝置請勿勾選。不可匯出金鑰不等於硬件保護，本機資料庫亦未因此全庫加密。",
    password: "設定復原密碼（至少 15 字元）",
    passwordHint: "可使用空格及密碼管理器。請自行保存檔案和密碼，課序不能替你重設。",
    prepare: "建立並下載加密復原檔",
    reselect: "重新選取剛下載的復原檔",
    openPassword: "輸入復原密碼",
    verifyFile: "驗證復原檔",
    fileVerified: "已確認這份復原檔可解鎖正確資料集",
    verification: "重要操作驗證",
    enroll: "設定生物辨識或 PIN",
    enrolled: "重要操作驗證已設定",
    totp: "使用驗證器代碼",
    enrollTotp: "改用驗證器設定",
    totpCode: "六位驗證器代碼",
    confirmTotp: "確認驗證器",
    activate: "啟用這份新同步",
    verifyOperation: "請驗證以完成這個指定操作",
    verifyConfirm: "開始驗證",
    cancel: "取消",
    working: "處理中…",
    googleStart: "準備 Google Drive 授權",
    googleOpen: "開啟 Google 授權",
    googleCheck: "重新檢查授權",
    binding: "確認 Drive 綁定",
    appAccount: "課序登入帳戶",
    driveAccount: "同步使用的 Drive",
    driveStorageHint:
      "同步資料會加密存放於此 Google 帳戶的課序專用空間，不會在一般 Drive 檔案列表中顯示，毋須自行選擇資料夾。",
    bindingHint: "兩個帳戶可以不同。這個課序帳戶啟用後固定綁定此 Drive；更換須先備份及明確遷移。",
    bindingConfirm: "我確認使用以上 Drive 保存同步密文",
    bind: "確認並連接此 Drive",
    retry: "重新連接／同步",
    oauthComplete: "Google 授權已完成。可回到原來的課序測試分頁，確認所選的 Drive 帳戶。",
    notConfigured: "同步服務暫未可用，本機資料仍保留。請稍後再試或聯絡支援。",
    offlineOpen: "以已記住的私人裝置離線開啟",
    offlineRead: "離線開啟不會延長筆記授權。到期後仍可查看及備份。",
    existingRoot: "這個帳戶已有同步。請用另一部已授權裝置配對，或選取加密復原檔。",
    pair: "掃碼配對",
    recover: "使用加密復原檔",
    chooseVersion: "保留這個版本",
    conflictHint: "兩個版本都已保留。請逐項選擇；如又收到新修改，會重新顯示版本。",
    changedRecord: "待選擇記錄 {{number}}",
    pageNumber: "第 {{number}} 頁",
    deletedVersion: "刪除這項內容",
    keptVersion: "保留內容及已保存的修改",
    boundDrive: "同步 Drive：{{email}}",
    deviceManagement: "連接其他裝置",
    connectedDevices: "已連接裝置",
    connectedDevicesHint: "以下裝置已獲准同步，不代表目前在線。",
    refreshDevices: "更新清單",
    currentDevice: "此裝置",
    deviceConnectedAt: "連接於 {{date}}",
    disconnectDevice: "中斷連接",
    disconnectNamedDevice: "中斷 {{name}}（{{id}}）的連接",
    disconnectDeviceTitle: "中斷 {{name}}（{{id}}）的連接？",
    disconnectDeviceHint: "此裝置將停止同步，原有本機資料仍保留。",
    confirmDisconnectDevice: "確認中斷連接",
    deviceDisconnected: "已中斷 {{name}} 的連接。",
    disconnectRecoveryHint: "這份同步曾設定復原檔。請先保存並驗證新的復原檔，舊檔將於中斷成功後失效。",
    devicesChanged: "裝置清單或同步資料已更新，請更新清單後再試。",
    showPairQr: "在這部裝置顯示配對 QR",
    scanPairQr: "掃描另一部裝置的 QR",
    pairScanHint: "在另一部裝置登入同一課序帳戶，開啟「同步設定」並選「掃描另一部裝置的 QR」。請勿分享或截圖保存此碼。",
    waitApproval: "已送出配對要求。請在已連接同步的裝置核對名稱，再按「批准配對」。",
    checkDevice: "核對要加入的裝置，然後完成重要操作驗證。",
    pairExpiry: "這個 QR 有效至 {{time}}",
    pairExpired: "配對已過期，請重新產生 QR。",
    pastePairUrl: "已有配對連結？",
    pairUrl: "短效配對連結",
    readPairUrl: "確認配對連結",
    approveDevice: "確認新增這部裝置：{{name}}",
    approvePair: "驗證並批准配對",
    pairApproved: "已批准配對。請回到新裝置，按「下載並連接現有同步」。",
    pairReading: "已讀取 QR，正在處理配對…",
    pairReady: "配對已批准。勾選「記住此私人裝置」，再按「下載並連接現有同步」。",
    pairConnecting: "配對已批准，正在連接並下載資料…",
    pairConnected: "配對成功，已連接此裝置。請開啟班別，核對最近的記錄。",
    connecting: "正在連接",
    pairFinishing: "正在完成配對，請稍候…",
    pairInterrupted: "配對已保存，但首次同步未完成。請按「重新連接／同步」繼續，毋須重新掃碼。",
    pairProgressChecking: "正在核對裝置",
    pairProgressCheckpoint: "正在驗證同步快照",
    pairProgressListing: "正在讀取同步檔案清單",
    pairProgressDownloading: "正在下載並驗證檔案",
    pairProgressApplying: "正在保存已驗證資料",
    pairProgressUploading: "正在傳送本機改動",
    pairProgressFinishing: "正在完成同步檢查",
    pairProgressCount: "{{completed}}／{{total}} 個檔案",
    pairSlow: "等待回應較久，配對設定仍保留",
    joined: "已連接同步；正在下載並驗證雲端內容。",
    cameraUnavailable: "未能使用相機，請允許相機存取，或改由另一端掃描。",
    existingLocalBarrier:
      "這端已有資料。先下載加密備份並重新選取驗證，才可選擇雲端取代本機；兩份既有資料不會自動混合。若要保留本機，請取消並另建同步世代。",
    backupPassword: "獨立備份密碼（至少 15 字元）",
    downloadJoinBackup: "下載取代前的獨立加密備份",
    reselectJoinBackup: "重新選取這次下載的備份",
    backupVerified: "已核對備份涵蓋目前本機內容",
    replaceFromCloud: "確認以雲端取代本機資料",
    joinCloud: "下載並連接現有同步",
    reenrollVerification: "為這部復原裝置登記重要操作驗證",
    keyManagement: "金鑰、復原及同步世代",
    recreateRecovery: "重新製作復原檔",
    recoveryWarning: "這會更換復原授權，但舊檔仍可能解密原有資料。若舊檔或密碼疑似外洩，請改用「輪替資料金鑰」。",
    rotateKey: "輪替資料金鑰",
    revokeDevice: "撤銷其他裝置並換鑰",
    newGeneration: "保留本機，另建同步世代",
    deviceToRevoke: "要撤銷的裝置",
    chooseDevice: "請選擇裝置",
    rotationWarning: "會建立新金鑰及新復原檔，只向仍有效的裝置發放後續金鑰；無法收回任何裝置已取得的舊資料。",
    generationWarning:
      "以目前本機資料建立新世代；舊雲端密文保留，舊待同步操作會隔離。其他裝置必須備份及明確確認加入，不能自動重播舊操作。",
    verifyAndCommit: "額外驗證並確認操作",
    managementDone: "操作已完成；請保管剛驗證的新復原檔。",
    legacyMigration: "從舊同步原型複製虛構資料",
    legacyMigrationHint:
      "只讀取這個網址內的舊同步測試資料庫。先在舊版完成待同步操作及版本選擇，再關閉舊測試分頁。未知資料表組合會停止；原資料庫及舊雲端密文保留。",
    findLegacy: "尋找舊測試資料庫",
    legacyFile: "舊測試資料庫",
    legacyNone: "這個網址未找到舊同步測試資料庫。不同網址或瀏覽器的資料須先從舊版匯出備份。",
    legacyPending: "舊版仍有待同步操作或競爭，請先回到舊版完成，原檔尚未改動。",
    importLegacy: "驗證備份並複製到這個空白測試資料庫",
    legacyCopied: "已複製本機資料。請建立新的 v2 同步；雲端讀回及檢查點驗證成功後，才停止使用舊版。",
    draftSaveRequired: "請先完成筆記保存。若草稿因世代改變而不能保存，請先下載草稿副本，再重新開啟頁面後連接。",
    backupCurrentRequired: "這份備份未能涵蓋目前本機內容，請重新下載並選取驗證。",
    maintenance: "正在遷移同步，暫停新修改；原資料仍保留。",
    rebindDrive: "備份並遷移到另一個 Drive",
    rebindWarning:
      "請先用 Google 授權選擇新的 Drive。核對新帳戶後，下載及驗證獨立備份與新的復原檔。程式會暫停這端修改，將資料加密複製並讀回新 Drive，成功後才換綁；原 Drive 密文保留。",
    newDriveAccount: "新的同步 Drive",
    selectNewDrive: "尚未選取，請先重新開啟 Google 授權",
    confirmNewDrive: "確認遷移至以上新的 Drive 帳戶",
    resumeMigration: "取消這端的遷移暫停並重新核對綁定",
    resetLostVerification: "我已遺失原有重要操作驗證方式，需要重設",
    resetVerificationHint:
      "只有有效復原檔、密碼及同一課序帳戶才可重設。重設會移除原有驗證方式；如移除已驗證的 TOTP，須重新登入並用同一復原檔接續。資料金鑰保留。",
    verificationResetReauth: "原有驗證方式已重設。請重新登入同一課序帳戶，再用同一復原檔接續，這次不用勾選重設。",
    reauthenticateRecovery: "重新登入並接續復原",
    restartWithReset: "改以復原檔重設遺失的驗證方式",
    draftCopyTitle: "下載這份筆記草稿的加密副本",
    draftCopyHint: "保留文字及向量筆畫，不重播到已改變的同步世代。稍後可在筆記匯入流程檢視及加入副本。",
    draftCopyDone: "加密草稿已下載。請確認檔案已保存，再重新開啟同步頁。",
    close: "關閉",
    initialUploadPending: "第一部裝置尚未完成首次同步及檢查點驗證，請先讓它保持開啟及連線。",
    keepLocalGeneration: "保留本機，改以新世代建立同步",
    keepLocalNext: "本機內容保持原樣。請到「金鑰、復原及同步世代」選擇另建世代，先備份及驗證，再完成指定操作驗證。",
    version: "版本 {{number}}",
    errorGeneric: "未能完成；本機資料及已保存操作仍保留。",
    errorConnection: "同步連線暫時未完成，已保存的操作會保留。",
    errorRate: "同步服務暫時限流，會稍後重試；本機資料及待同步操作保留。",
    errorGoogleAuth: "請重新授權原來綁定的 Google Drive；本機資料及裝置解鎖能力保留。",
    errorCorrupt: "同步檔案未通過驗證。本機資料及待同步操作保留，請先製作獨立備份並檢查同步來源。",
    errorRecovery: "復原檔、密碼或資料集不符，請核對後重試。",
    errorClock: "裝置時間倒退，筆記離線授權已停止；請校正時間並重新連接。",
    errorAccount: "需要重新驗證課序帳戶。資料仍保留，可查看及備份。",
    errorDevice: "此裝置需要重新授權。資料仍保留，可查看及備份。",
    errorUpdate: "另一部裝置已使用較新版本的課序。請更新此裝置後再同步。資料仍保留，可查看及備份。",
    errorCapacity: "同步容量或 Drive 空間不足；已停止新上傳並保留資料。",
    errorConflict: "請先選擇要保留的版本；期間的新版本會重新核對。",
    errorGeneration: "雲端同步世代已改變，請先備份本機資料，再確認下一步。",
    errorKey: "同步金鑰已更新，正在等待安全取得新金鑰。",
    errorLegacy: "這份舊同步須先處理待同步操作及驗證備份，原資料庫未被升級。",
    errorPaused: "已暫停同步；回到此頁後再繼續。",
    errorReadOnly: "筆記修改授權已到期或尚未解鎖，請重新連接。",
    recoveryFileName: "課序同步復原檔",
    totpScan: "用你的驗證器掃描此 QR，然後輸入代碼。",
    totpExisting: "輸入已登記驗證器目前顯示的代碼。",
    localScope: "測試資料庫：{{device}}",
    showClassroom: "課堂與筆記",
    rootReady: "新同步已建立，請連接並確認 Google Drive。",
  },
  personalTools: {
    coursework: {
      title: "待處理課業",
      total: "{{classes}} 班・{{tasks}} 份",
      tasks: "{{count}} 份",
      tasks_one: "{{count}} 份",
      tasks_other: "{{count}} 份",
      openClass: "查看 {{name}} 的 {{count}} 份待處理課業",
      openClass_one: "查看 {{name}} 的 {{count}} 份待處理課業",
      openClass_other: "查看 {{name}} 的 {{count}} 份待處理課業",
    },
    dayLabel: "我的日程",
    globalNavigation: "我的工作",
    workHome: "我的工作台",
    workHomeHint: "查看日程，或選一班開始上課。",
    agendaEntryHint: "查看日程與課堂事項",
    classContext: "目前班別",
    demoMode: "示範資料",
    permanentlyDelete: "永久刪除",
    blank: "空白",
    saved: "已自動保存",
    saving: "保存中…",
    cancel: "取消",
    close: "關閉",
  },
  toolPage: {
    more: "更多",
    overflow: "切換工具分頁",
    closeHelp: "關閉使用說明",
    help: {
      coursework: {
        title: "課業與成績使用說明",
        first: "在「課業概覽」查看近期評核及需要跟進的課業。",
        second: "在「事項記錄」選擇課業，記錄分數及繳交／應考狀態。",
        third: "「成績總表」可篩選及匯出成績；在「課業概覽」按「跨學期對比」比較各學期表現。",
      },
      calendar: {
        title: "日曆使用說明",
        first: "按「＋ 新增事項」或日曆日期，加入功課、測驗、默書或提醒。",
        second: "功課、測驗及默書會連動「課業與成績」，可到「事項記錄」登分及更新狀態。",
        third: "用篩選切換校曆及各類事項；點選已有事項可查看詳情。",
      },
    },
  },
  schoolYears: {
    backupScope: "備份包含所有學年；還原會取代所有學年的本地資料。",
    selector: "學年",
    manage: "管理學年",
    title: "學年管理",
    open: "使用中",
    archived: "已封存",
    current: "預設學年",
    dateCurrent: "本學年",
    history: "歷年資料",
    viewYear: "查看 {{name}}",
    returnCurrent: "返回本學年",
    viewing: "正在查看 {{name}}",
    preparing: "正在準備 {{name}}",
    prepareNext: "準備下學年",
    continuePreparing: "繼續準備",
    nextYear: "下學年",
    future: "準備中",
    editable: "可修改",
    setCurrent: "設為預設",
    archive: "封存",
    reopen: "重新開放",
    create: "新增學年",
    startYear: "開始年份",
    source: "沿用班別設定",
    empty: "全新建立",
    createHint: "新學年只沿用班別及設定；學生名單、紀錄及已選學生不會複製。",
    legacyHint: "原有資料保留完整，沒有按日期重新分配。",
    archiveHint: "封存後可查看及匯出；需要修改時可重新開放。",
    archiveConfirm: "封存「{{name}}」？紀錄會保留，並停止修改。",
    reopenConfirm: "重新開放「{{name}}」，容許修改紀錄？",
    readOnly: "此學年已封存，只供查看及匯出。",
    readOnlyError: "此學年已封存，請先到學年管理重新開放。",
    unsaved: "仍有未儲存的改動，要放棄並切換學年嗎？",
    busy: "正在儲存，請完成後再切換學年。",
    saved: "學年設定已保存",
    delete: "刪除整個學年",
    deleteTitle: "刪除學年資料",
    deleteHint: "將永久刪除「{{name}}」的班別、學生及所有紀錄。其他學年會保留。",
    counts: "{{classes}} 個班別 · {{students}} 位學生 · {{records}} 筆資料",
    confirmation: "輸入學年名稱確認",
    backupFirst: "先下載所有學年的加密備份",
    backupChecked: "我已保存可還原的備份",
    cancel: "取消",
    confirmDelete: "永久刪除",
    close: "關閉學年管理",
    failed: "未能保存學年設定；原有資料已保留。",
    duplicate: "此學年已存在。",
    invalid: "請輸入有效的開始年份。",
    stale: "資料已有變更，請重新檢視刪除範圍。",
    chooseYear: "先選擇要處理的學年",
    termSetup: "重設學期",
    selected: "正在查看",
    switchFailed: "未能切換學年。",
  },
  dailyMemos: {
    tabs: "班務事項分頁",
    memos: "日常備忘",
    affairs: "班務記事",
    count: "{{count}} 位",
    count_one: "{{count}} 位",
    count_other: "{{count}} 位",
    add: "新增備忘",
    placeholder: "例如：自行回家",
    edit: "編輯名單",
    done: "完成",
    delete: "刪除",
    deleteLabel: "刪除{{title}}",
    deleteConfirm: "刪除「{{title}}」及其已選學生名單？",
    noSelected: "尚未選擇學生",
    noStudents: "尚未加入學生名單",
    empty: "尚未有日常備忘",
    selected: "已選擇",
    unselected: "未選擇",
    selectStudent: "選擇 {{number}} 號 {{name}}",
    unselectStudent: "取消選擇 {{number}} 號 {{name}}",
    duplicate: "這項備忘已存在，請使用另一個名稱。",
    stale: "這項備忘已被移除，請重新選擇。",
    failed: "未能保存備忘，請再試一次。",
    missingClass: "找不到班別。",
  },
  historyImport: {
    title: "記錄匯入",
    method: "匯入方式",
    methods: { excel: "Excel", csv: "CSV", paste: "貼上表格" },
    fileLabels: { excel: "Excel 檔案（.xlsx，最多 10 MB）", csv: "CSV 檔案（.csv，最多 10 MB）" },
    encoding: "CSV 編碼",
    encodings: { utf8: "UTF-8", big5: "繁體中文（Big5）" },
    paste: "表格內容",
    analyze: "讀取表格",
    pastedSheet: "貼上表格",
    reading: "正在讀取資料…",
    readFailed: "未能讀取資料。",
    sourceRow: "資料行",
    overwrite: "允許逐行選擇覆蓋現有記錄",
    errors: {
      fileType: "請選擇 .csv 檔案。",
      size: "資料不可大於 10 MB。",
      empty: "沒有可讀取的資料。",
      quotes: "表格的引號格式不完整，請修正後再試。",
      columns: "每份表格最多 80 欄。",
      rows: "每份表格最多 5,000 筆資料，請分拆後匯入。",
      encoding: "檔案編碼不符，請切換 CSV 編碼後重試。",
    },
  },
  brand: {
    name: "課序",
    english: "Class in Order",
    symbol: "課",
    tagline: "老師的課堂與班務工作台",
    transition: "原課堂經營",
    home: "課序首頁",
    monthlyPlan: "課序月費方案",
    backupFilenamePrefix: "課序-加密備份",
  },
  landing: {
    title: "上課時記下，<br/><strong>課後少補記。</strong>",
    description: "學生一回答，點選座位卡就能記下。用 iPad 或電腦，讓課堂記錄跟上上課節奏，少一份課後補記的工作。",
    demoAction: "免登入體驗示範課堂",
    betaAction: "登入 Free Trial →",
    supportingLine: "把一堂課的細節接住。",
    skip: "跳到主要內容",
    navigation: "首頁導覽",
    demoNav: "體驗 Demo",
    trialNav: "開始試用",
    trialPreview: "預覽 Free Trial",
    entryNote: "Demo 免登入 · Free Trial 本機保存 · 毋須信用卡",
    previewLabel: "課序 · 課堂工作台",
    heroAlt: "課序工作台預覽：學生紀錄（虛構示範資料）",
    previewCaption: "實際產品畫面 · 所有班級及學生資料均為虛構示範",
    highlightDemo: "免登入體驗 Demo",
    highlightLocal: "Free Trial 資料保存在本機",
    highlightBackup: "可下載加密備份",
    featuresKicker: "從上課到課後跟進",
    featuresTitle: "這堂課記下的，課後接著用。",
    featuresDescription: "當場記錄、按學生彙整、找到跟進依據。讓一次記錄，接上課後的工作。",
    recordDemoLabel: "上課記錄操作示意",
    recordDemoClass: "2A · 課堂回應",
    recordDemoBadge: "試按看看",
    recordDemoInstruction: "點選學生，記下回答次數",
    recordDemoBlackboard: "黑板 · 教師視角",
    recordDemoAnswer: "為 {{number}} 號 {{name}}記一次回答",
    recordDemoNumber: "{{number}} 號",
    recordDemoCount: "{{count}} 次回答",
    recordDemoCount_one: "{{count}} 次回答",
    recordDemoCount_other: "{{count}} 次回答",
    recordDemoTotal: "今天累計 {{count}} 次回答",
    recordDemoTotal_one: "今天累計 {{count}} 次回答",
    recordDemoTotal_other: "今天累計 {{count}} 次回答",
    recordDemoSave: "保存今日記錄",
    recordDemoReady: "試按一張座位卡，看看回答次數怎樣更新。",
    recordDemoDirty: "已記下，尚未保存。接著按「保存今日記錄」。",
    recordDemoSaved: "示意完成！到 Demo 體驗完整的課堂記錄。",
    recordDemoNotice: "操作示意，不會寫入班級資料。",
    recordDemoReset: "重設操作示意",
    sampleStudent1: "陳幼羚",
    sampleStudent2: "李允行",
    sampleStudent3: "黃允行",
    sampleStudent4: "張英秀",
    sampleStudent5: "林修端",
    sampleStudent6: "何幼羚",
    trustLabel: "本機資料保存",
    trustTitle: "你的學生紀錄，留在自己的裝置。",
    trustDescription: "Free Trial 本機保存，不上傳學生名單與課堂紀錄。",
    trustAction: "了解保存與備份",
    perspectiveKicker: "更全面地了解學生",
    perspectiveTitle: "分數以外，也看見學生怎樣參與。",
    perspectiveDescription:
      "平日用 Excel 記分，課堂回應、作業和備註卻可能散在其他地方。課序把這些資料放在同一個平台，方便一併查閱，更全面地評核學生表現。",
    perspectiveDetail: "沿用同一份學生名單，按需要查閱各類紀錄與學期概覽，減少來回翻找幾份表格。",
    typeGrades: "成績",
    typeAnswers: "課堂回應",
    typeHomework: "作業繳交",
    typeAttendance: "出勤",
    typeMaterials: "書簿準備",
    typeNotes: "備註",
    overviewLabel: "自動彙整",
    overviewTitle: "誰需要再跟進，不必逐筆數。",
    overviewDescription: "系統按學生彙整回答次數及欠帶書簿日數。篩選曾欠帶書簿的學生，課後更快找到需要留意的情況。",
    overviewDetail: "可按學生、日期或記錄範圍查看，亦能匯出需要的資料。",
    overviewAlt: "按學生彙整的課堂記錄與篩選（虛構示範資料）",
    followupLabel: "個別學生跟進",
    followupTitle: "跟進學生，拿得出具體記錄。",
    followupDescription:
      "打開學生的逐日記錄，就能查看回答次數、書簿準備和備註。與學生或家長談起近況時，找得到日期和事情經過，減少只靠印象。",
    followupDetail: "從全班概況到個別學生的細節，幫助你決定下一步怎樣跟進。",
    followupAlt: "學生逐日記錄與備註（虛構示範資料）",
    supportKicker: "接上你原有的工作方式",
    supportTitle: "記錄與整理，都少做一步。",
    transferLabel: "匯入與匯出",
    transferTitle: "原有 Excel 紀錄，也能接著用。",
    transferDescription: "匯入支援的 Excel 或 CSV 紀錄，先預覽及對應欄位，再確認匯入，減少逐筆重新輸入。",
    transferStep1: "選擇檔案",
    transferStep2: "預覽與對應欄位",
    transferStep3: "確認匯入",
    transferDetail: "需要製作報表時，按學生、日期或事項篩選，再匯出到試算表使用。",
    courseworkLabel: "功課、測驗與登分",
    courseworkTitle: "功課、測驗看得清，<br/>登分更順手。",
    courseworkDescription:
      "每份功課、測驗和默書，繳交日期、欠交名單與評分進度一眼可見。點開記錄，便能按學生輸入分數、更新繳交狀態，毋須另開表格逐項對照。",
    courseworkDetail: "誰未交、誰已補交、還有多少人未評分，同一處看清。",
    courseworkAlt: "測驗事項的繳交狀態及評分進度（虛構示範資料）",
    courseworkEntryAlt: "逐位學生的繳交狀態與分數輸入欄位（虛構示範資料）",
    courseworkListStep: "① 查看繳交狀態與評分進度",
    courseworkEntryStep: "② 點開記錄，按學生登分",
    gradesLabel: "功課與成績",
    gradesTitle: "登分後，全班表現自動整理。",
    gradesDescription: "已記錄的分數自動整理成平均得分率和分布。按功課、測驗或默書查看全班概況，再查閱個別學生的成績。",
    gradesDetail: "從逐份登分到全班概覽，減少另外製表和計算。",
    gradesAlt: "功課與成績示範畫面（虛構資料）",
    seatingLabel: "座位與班務",
    seatingTitle: "把班級安排，放回課堂現場。",
    seatingDescription: "整理座位、學生職務及日常班務。配合學生名單使用，讓課堂上的安排和課後的紀錄接得上。",
    seatingDetail: "同一個工作台，兼顧任教課堂與班主任工作。",
    seatingAlt: "座位表與班務示範畫面（虛構資料）",
    featureAction: "到示範課堂試試",
    featureCaption: "虛構示範班級 · 實際介面截圖",
    dataKicker: "資料保存方式",
    dataTitle: "學生與課堂紀錄，留在自己的裝置。",
    dataDescription:
      "Free Trial 的學生名單與課堂紀錄保存在目前裝置的瀏覽器，不會把這些資料上傳至雲端。由你保管，也由你決定何時匯出與備份。",
    localTitle: "在目前裝置保存",
    localDescription:
      "學生名單及課堂紀錄保存在目前裝置的瀏覽器，本機課堂資料不會傳到伺服器。Free Trial 仍需連線檢查帳戶使用權限。",
    backupTitle: "把備份帶走",
    backupDescription: "可以手動下載加密備份，請定期備份並分開保管密碼。還原備份會取代現有本機資料，操作前須先確認。",
    dataTitleSynced: "資料留在裝置，同步由你決定。",
    dataDescriptionSynced:
      "課堂資料先保存在目前瀏覽器。你可自願開啟 Google Drive 同步，讓加密後的資料在自己的裝置間接續使用。",
    localDescriptionSynced:
      "學生名單及課堂紀錄保存在目前裝置的瀏覽器；啟用同步後才會把同步資料加密傳送到你授權的 Drive。Free Trial 仍需連線檢查使用權限。",
    syncAvailableTitle: "按需要開啟跨裝置同步。",
    syncAvailableDescription:
      "Free Trial 用戶可選擇啟用 Google Drive 同步，其他私人裝置首次掃 QR 配對一次；也可以稍後再設定。",
    syncTitle: "Free Trial 暫時只支援 1 部裝置。",
    syncDescription:
      "請在同一部裝置、同一個瀏覽器使用。登入不代表跨裝置同步；更換裝置或瀏覽器後，紀錄不會自動出現。清除網站資料可能失去紀錄，請先下載加密備份。",
    trialKicker: "由一個示範班級開始",
    trialTitle: "先試一堂課，再決定。",
    trialDescription: "先用 Demo 熟悉操作，再登入 Free Trial 管理自己的班級及課堂記錄。",
    demoTitle: "先看示範",
    demoDescription: "免登入，用虛構班級試操作。資料只留在今次瀏覽，重新載入即可重設。",
    demoFeature1: "直接體驗操作台",
    demoFeature2: "不保存真實資料",
    demoFeature3: "可隨時重設示範資料",
    demoFeature4: "毋須檢查帳戶使用權限",
    demoEntry: "進入 Demo",
    betaTitle: "Free Trial 本機試用",
    betaIndex: "02 / FREE TRIAL",
    betaDescriptionSynced:
      "登入後建立自己的班別及記錄。資料先保存在本機，也可自選 Google Drive 同步，在自己的電腦和 iPad 接續使用。",
    betaFeature3Synced: "可選跨裝置同步，另備獨立加密備份",
    betaDescription:
      "Free Trial 暫時只支援 1 部裝置。登入後使用自己的班級及課堂資料，紀錄保存在該裝置的瀏覽器。亦可安裝成 PWA，由主畫面直接開啟。",
    betaFeature1: "可用於真實課堂，須符合學校規定及資料保障要求；毋須信用卡。",
    betaFeature3: "可手動下載加密備份",
    betaFeature4: "啟動及回到前景時需要連線檢查使用權限",
    betaDetails: "查看連線及唯讀安排",
    betaAccessNotice:
      "網絡故障時，上次成功檢查起 10 分鐘內可繼續保存；之後只可讀取，仍可查閱、匯出及下載加密備份。授權到期或撤銷會即時轉為唯讀，不會刪除本機資料。",
    betaDataNotice: "更換瀏覽器不會自動同步；清除網站資料可能失去紀錄，請定期下載加密備份。",
    betaEntry: "立即在瀏覽器試用",
    availability: "本機小測暫未開放。收費版及其裝置、備份、取消退款和換裝置政策，會在推出前另行公布。",
    legalNavigation: "法律資料",
    supportLink: "支援及帳戶刪除",
    privacyLink: "私隱政策及收集個人資料聲明",
    termsLink: "服務條款",
    processingLink: "學校資料處理條款",
  },
  ipadGuide: {
    kicker: "iPad 使用指南",
    title: "把課序加入主畫面，<br/>上課時，一按即開。",
    lead: "將課序放到 iPad 主畫面，下次點按「課序」圖示，就能像開啟 App 一樣使用，毋須每次輸入網址或尋找分頁。",
    firstUse: "<strong>第一次使用？</strong>建議先完成以下設定，再從主畫面的「課序」圖示登入及建立班級。",
    reminderTitle: "加入主畫面後，請固定從「課序」圖示開啟。",
    reminder:
      "<strong>主畫面的課序與 Safari 會分開保存資料。</strong>即使在同一部 iPad、登入同一帳戶，也不會自動共用本機記錄，請避免在兩個入口之間交替使用。",
    reminderExtra: "Chrome 及其他 App 內的瀏覽器也可能使用不同的儲存空間。請在每部裝置上固定使用同一個入口。",
    stepsTitle: "四步加入主畫面",
    illustrativeNote: "操作示意；畫面及選項名稱可能因 iPadOS 版本而不同。",
    stepShareTitle: "在 Safari 點按「分享」",
    stepShareDescription: "用 Safari 開啟課序，點按「分享」圖示。",
    stepShareAlt: "操作示意：在 Safari 開啟課序，點按工具列上的分享按鈕；圖示是向上箭頭伸出方框。",
    stepChooseTitle: "選擇「加入主畫面」",
    stepChooseDescription: "在分享選單選擇「加入主畫面」。如有顯示「檢視更多內容」，請先點按它。",
    stepChooseAlt: "操作示意：在分享選單找到並點按加入主畫面。部分版本須先點按檢視更多內容。",
    stepConfirmTitle: "確認名稱，再點按「加入」",
    stepConfirmDescription: "確認名稱為「課序」。如有「打開為網頁 App」選項，請保持開啟，再點按「加入」。",
    stepConfirmAlt: "操作示意：名稱設為課序；如有打開為網頁 App 選項，保持開啟，再點按右上角的加入。",
    stepOpenTitle: "以後從同一個圖示開啟",
    stepOpenDescription: "回到 iPad 主畫面，點按「課序」圖示。之後請固定使用這個入口。",
    stepOpenAlt: "操作示意：在 iPad 主畫面點按課序圖示開啟。之後固定從這個圖示進入課序。",
    websiteLabel: "課序網站",
    brandName: "課序",
    shareLabel: "點按「分享」",
    shareMenuLabel: "網站分享選單",
    copyLabel: "拷貝",
    bookmarkLabel: "加入書籤",
    addToHomeLabel: "加入主畫面",
    cancelLabel: "取消",
    addLabel: "加入",
    openAsAppLabel: "打開為網頁 App",
    optionalToggleHint: "如有此選項，請保持開啟",
    homeScreenLabel: "iPad 主畫面",
    illustrationLabel: "操作示意",
    notesAppLabel: "備忘錄",
    safariLabel: "Safari",
    alwaysOpenHere: "以後都從這裡開啟",
    existingTitle: "已經在 Safari 或其他瀏覽器建立了班級？",
    existingDescription:
      "加入主畫面不會自動搬移原有記錄。首次從圖示開啟後，請先核對班級及資料；<strong>若沒有看到原有記錄，請返回原本的入口查看，避免重複建班或清除網站資料。</strong>",
    existingExtra: "未確認資料已在新入口可用前，請先從原本的入口繼續使用。",
    syncNote:
      "需要在電腦與 iPad 接續使用？請另行完成跨裝置同步設定及配對；每部裝置仍應固定使用自己的入口，切換前確認最新改動已在另一端出現。",
    syncLink: "查看跨裝置同步指南",
    appleLink: "Apple 操作說明",
    webkitLink: "WebKit 資料儲存說明",
    spotlightKicker: "iPad 使用指南",
    spotlightTitle: "加入主畫面，上課時一按即開。",
    spotlightDescription: "跟著四步圖解設定。之後固定從同一個「課序」圖示開啟，避免在不同入口之間交替使用。",
    spotlightLink: "查看加入主畫面圖解",
  },
  marketing: {
    syncSpotlightTitle: "電腦備課，iPad 接著上課。",
    syncSpotlightDescription:
      "開啟 Google Drive 同步，讓自己的裝置接續同一份班別與記錄。首次連接、掃 QR 配對，之後開著課序並連網便會自動同步。",
    syncSpotlightPreview:
      "跨裝置同步已加入首次設定引導。先看看連接 Drive 和 QR 配對的方式；實際可用情況以工作台的同步入口為準。",
    syncGuideLink: "查看同步圖解與設定教學",
    syncHeroLink: "電腦與 iPad，怎樣接續使用？",
    syncComputer: "你的電腦",
    syncTablet: "你的 iPad",
    syncEncrypted: "裝置加密後傳送",
    syncSampleClass: "2A · 課堂記錄",
    syncSampleRecord: "已記下課堂回應",
    syncDiagramCaption: "流程示意 · 同一老師的私人裝置，經授權的 Drive 接續記錄",
    syncScreenshotOpen: "放大查看：{{title}}（新分頁）",
    syncScreenshotAlt: "{{title}}的實際課序介面截圖，使用虛構資料",
    syncScreenshotEnlarge: "按圖放大",
    syncGuideNavigation: "同步教學章節",
    syncBrowserTitle: "每部裝置，固定同一個入口",
    syncBrowserDescription:
      "請先選定每部裝置日常使用的瀏覽器或主畫面圖示，從該入口完成同步設定，之後固定使用。目前已測試 Chrome 的同步流程；Safari 與主畫面 App 的完整實機同步驗證仍待完成。",
    syncIpadGuideLink: "iPad 加入主畫面與固定入口說明",
    syncGuidePreviewNotice:
      "以下為設定流程預覽。此建置尚未向一般用戶開放同步；看到工作台的「同步設定」入口後，才可按步驟啟用。",
    syncOverviewKicker: "先了解保存方式",
    syncOverviewTitle: "同一份記錄，在自己的裝置接續。",
    syncOverviewDescription:
      "資料先保存在裝置；啟用後，同步範圍內的班別、學生、課堂、功課、出勤、座位與工具設定，會加密傳送到你選定的 Drive 應用程式空間。課序不會讀取其他 Drive 檔案。",
    syncFirstTitle: "設定第一部裝置",
    syncFirstLead:
      "從已有班別與記錄的裝置開始，先下載一份最新加密備份。以下為實際課序介面截圖，使用虛構帳戶，以電腦瀏覽器擷取。裝置名稱及版面會因裝置而異；按圖可放大。",
    syncFirstStep1Title: "開啟同步設定",
    syncFirstStep1:
      "完成首次建班後，選「設定跨裝置同步」；也可隨時從頁首「同步設定」開啟。勾選「記住此私人裝置」，再按「啟用 Google Drive 同步」。",
    syncFirstStep2Title: "授權 Google Drive",
    syncFirstStep2:
      "按「準備 Google Drive 授權」，再按「開啟 Google 授權」。在 Google 頁選擇保存同步資料的帳戶並授權，回到原來的課序分頁按「重新檢查授權」。",
    syncFirstStep3Title: "核對帳戶，確認連接",
    syncFirstStep3:
      "核對「課序登入帳戶」與「同步使用的 Drive」。兩者可以不同；確認選對後，勾選確認並按「確認並連接此 Drive」。看到「已連接 Google Drive」後，等候首次同步完成。",
    syncOptionalNote: "同步是自選功能。選「稍後設定」仍可在本機使用；稍後從頁首開啟即可，毋須重新建班。",
    syncPairTitle: "加入另一部裝置",
    syncPairLead:
      "兩邊都開啟同一課序網址並連網。在新裝置登入同一課序帳戶；已有同步時，會先顯示配對入口，毋須再次建班。截圖中的配對碼已遮蓋，不能掃描。",
    syncPairStep1Title: "電腦顯示 QR，iPad 掃描",
    syncPairStep1:
      "在已連接的電腦開啟「同步設定」→「連接其他裝置」→「在這部裝置顯示配對 QR」。在 iPad 的課序配對頁，按「掃描另一部裝置的 QR」並允許相機。也可交換兩邊的顯示與掃描角色。",
    syncPairStep2Title: "回到原裝置批准",
    syncPairStep2:
      "在原有裝置核對要加入的裝置名稱，按「批准配對」。首次加入只需這次 QR 配對，不用設定 Touch ID、PIN 或自行管理同步金鑰。",
    syncPairStep3Title: "新裝置下載，再核對記錄",
    syncPairStep3:
      "回到 iPad，勾選「記住此私人裝置」，按「下載並連接現有同步」。保持頁面開著，等候下載完成，再打開原有班別，核對一項最近修改的記錄。",
    syncQrNote:
      "QR 只供自己的裝置即時配對，請勿分享或截圖保存。過期時重新產生；相機不可用時，可交換兩部裝置的顯示與掃描角色。",
    syncDailyKicker: "日常使用",
    syncDailyTitle: "換裝置前，多看一眼。",
    syncDailyLead: "首次設定後，課序在開啟並連網時自動同步。關閉瀏覽器或裝置休眠期間，不保證持續同步。",
    syncDailySave: "在原裝置完成修改，先等「本機已保存」。",
    syncDailyWait: "保持課序開著並連網，等「待同步」變成「此裝置已同步」。",
    syncDailyRead: "在另一部裝置打開相同班別與記錄，確認剛才的改動已出現，再繼續工作。狀態提示本身不代表另一端已收到。",
    syncHelpTitle: "設定時遇到這些情況",
    syncHelpLocalTitle: "新裝置已經有另一份本機資料？",
    syncHelpLocal:
      "配對會停止並保留本機資料，兩份既有資料不會自動合併。請先在原有裝置繼續使用，下載獨立加密備份，再從支援頁聯絡處理；不要清除網站資料或反覆重新配對。",
    syncHelpConnectionTitle: "顯示「待同步」或「需要重新連接」？",
    syncHelpConnection:
      "先保持兩邊的課序在前景並連網，從「同步設定」按「重新連接／同步」。如畫面要求重新授權，請選回原先綁定的 Drive。改動未在另一端出現前，先留在原裝置繼續核對；不要清除資料。",
    syncHelpConflictTitle: "顯示「有版本需要選擇」？",
    syncHelpConflict:
      "開啟「同步設定」，逐項核對並選擇保留的版本，再到另一端確認結果。先處理版本差異，避免同時繼續修改同一筆記錄。",
    syncHelpBackupTitle: "已同步，還需要備份嗎？",
    syncHelpBackup:
      "需要。同步會傳送修改與刪除，不能取代獨立備份。請定期下載加密備份，分開保管檔案及密碼，並保留至少一部已配對裝置及其網站資料。若全部已配對裝置的網站資料都遺失，單靠 Google 登入不能解密雲端內容。",
    pointSyncAvailable: "電腦與 iPad 接續使用",
    dataTeaserTitleSynced: "本機保存，<br/>也能跨裝置接續。",
    dataTeaserDescriptionSynced:
      "課堂資料先留在自己的裝置。自選開啟 Google Drive 同步後，才把同步資料加密傳送到你授權的 Drive。",
    dataTeaserDetailSynced: "其他私人裝置首次掃 QR 配對。同步與獨立加密備份，兩者都保留。",
    faqStorageAnswerSynced:
      "資料先保存在目前瀏覽器。自願啟用 Google Drive 同步後，同步範圍內的資料會在裝置加密，再傳送到你授權的 Drive 應用程式空間；不讀取其他 Drive 檔案。未啟用時，登入不會上傳課堂資料。",
    faqSyncAnswerAvailable:
      "可以。有效 Free Trial 帳戶可自選啟用 Google Drive 同步，再在其他私人裝置登入同一課序帳戶、掃 QR 配對及下載。單靠登入不會收到記錄；請先完成配對，並在另一端核對最新改動。設定步驟見「跨裝置同步」分頁。",
    faqQuizAnswerSynced:
      "網上小測與 AI 出題仍未開放。Google Drive 跨裝置同步已提供給有效 Free Trial 帳戶自選，須另行啟用及配對；詳見「跨裝置同步」分頁。",
    dataPageDescriptionSynced: "了解課序的本機資料保存、自選 Google Drive 跨裝置同步、帳戶連線與獨立加密備份。",
    dataPageLeadSynced:
      "學生與課堂記錄先保存在本機；你可選擇啟用 Google Drive 同步，在自己的電腦和 iPad 接續使用。登入、同步與獨立備份各有不同用途。",
    homePageTitle: "課序｜老師的課堂與班務工作台",
    homeNav: "首頁",
    dataNav: "資料與備份",
    guideNav: "使用指南",
    ipadNav: "iPad 使用指南",
    ipadPageTitle: "課序｜iPad 使用指南",
    ipadPageDescription:
      "四步圖解教你將課序加入 iPad 主畫面，了解固定入口及主畫面 App 與 Safari 分開保存資料的注意事項。",
    syncNav: "跨裝置同步",
    siteNavigation: "網站導覽",
    entryNavigation: "試用入口",
    footerNavigation: "網站資訊",
    heroKicker: "給科任老師，也給班主任",
    heroTitle: "把課堂記錄，<br/><strong>變成跟進的依據。</strong>",
    heroDescription:
      "課堂回應、功課分數、出勤與班務安排，在同一個工作台整理。從全班概況到個別學生紀錄，讓日常教學與後續跟進有據可查。",
    heroScreenLabel: "課序 · 課堂與班務工作台",
    heroAlt: "最新版課序的課堂回應座位卡、回答統計與任教工具（虛構 Demo 資料）",
    heroCaption: "實際產品畫面 · 虛構示範資料",
    heroLink: "看看課序能做甚麼",
    pointLanguage: "帶著 iPad 即場記錄",
    pointRoles: "課堂班務集中整理",
    pointDevices: "匯出成績，方便製表",
    pointStorage: "學生資料本機保存",
    missionKicker: "課序想解決的日常",
    missionTitle: "老師的隨身工具箱，<br/>讓記錄跟著課堂走。",
    missionDescription: "帶著 iPad 上課，走到學生身旁，隨手記下當下的觀察。",
    missionBenefit: "減少下課後憑記憶補記。",
    missionTeaching: "科任老師",
    missionTeachingDescription: "在不同班別之間切換，接著處理當天的課堂與課業。",
    missionHomeroom: "班主任",
    missionHomeroomDescription: "安排班級座位，處理自己班級的日常事務。",
    teachingToolsTitle: "任教工具",
    teachingToolsDescription: "記錄課堂、跟進功課、整理成績。",
    homeroomToolsTitle: "班主任工具",
    homeroomToolsDescription: "處理班務，掌握學生的日常情況。",
    captureTab: "課堂記錄",
    captureTitle: "按座位記錄，<br/>回答次數即時彙整。",
    captureDescription:
      "點選學生座位卡記下回答，配合欠帶書簿與備註記錄。全班統計呈現參與情況，再按學生或日期查看詳細紀錄，找到需要跟進的地方。",
    capturePoint1: "座位卡記錄課堂回應",
    capturePoint2: "回答次數及欠帶書簿日數自動彙整",
    capturePoint3: "查閱學生逐日記錄與備註",
    captureAlt: "課堂表現總覽的回應次數、欠帶書簿日數及學生篩選（虛構 Demo 資料）",
    gradesTab: "功課跟進",
    gradesTitle: "誰未交、誰未評分，<br/>同一處看清。",
    gradesDescription:
      "把功課、測驗與默書的繳交狀態和分數一起記下。課業概覽集中列出欠交、待評分及未記錄的事項，讓你知道下一步要跟進甚麼。",
    gradesPoint1: "記錄準時繳交、欠交及補交",
    gradesPoint2: "按學生登分，查閱已保存的記錄",
    gradesPoint3: "由課業概覽直接開啟待跟進項目",
    gradesAlt: "課業概覽中的待評分、欠交及最近評核（虛構 Demo 資料）",
    reportsTab: "成績報表",
    reportsTitle: "成績自動彙整，<br/>匯出後繼續整理。",
    reportsDescription:
      "已保存的功課、測驗與默書分數彙整成成績總表。按課業或學生篩選，再匯出 Excel 或 CSV，方便老師沿用數據整理分表；需要閱讀或列印時，也可匯出 PDF。",
    reportsPoint1: "全班分數與繳交狀態彙整成表",
    reportsPoint2: "匯出 Excel／CSV，方便整理分表",
    reportsPoint3: "匯出 PDF 或列印成績報表",
    reportsAlt: "成績總表匯出預覽與 Excel、CSV、PDF、JSON 選項（虛構 Demo 資料）",
    termsTab: "學期比較",
    termsTitle: "由當日記錄，<br/>看到整個學期的變化。",
    termsDescription:
      "按學期查閱已保存的課業記錄，對照學生需要跟進的情況，再展開個別學生的逐月變化。把零散的日常記錄連起來，讓後續跟進更有依據。",
    termsPoint1: "按學期及課業類型查閱",
    termsPoint2: "比較不同學期的待跟進情況",
    termsPoint3: "展開學生的各學期與逐月記錄",
    termsAlt: "任教班別的學期比較入口、篩選及學生待跟進比例（虛構 Demo 資料）",
    groupsTab: "抽人與分組",
    groupsTitle: "抽人、分組，<br/>沿用同一份班級名單。",
    groupsDescription:
      "上課需要抽選學生或安排小組時，直接使用班級名單。隨機抽人可在本輪避免重複；分組則按每組人數或組數安排，減少即場逐個分配的時間。",
    groupsPoint1: "隨機抽人，本輪不重複",
    groupsPoint2: "按每組人數或組數產生分組",
    groupsPoint3: "查看抽選歷史及分組名單",
    groupsAlt: "任教班別按每組人數產生的分組名單（虛構 Demo 資料）",
    attendanceTab: "點名",
    attendanceTitle: "按座位點名，<br/>全班出勤即時看清。",
    attendanceDescription:
      "沿用班級座位表，點選學生切換出席或缺席，記錄即時保存。全班統計隨點名更新，可按日期查閱，方便日後跟進。",
    attendancePoint1: "座位卡切換出席及缺席",
    attendancePoint2: "即時查看全班點名統計",
    attendancePoint3: "點選即保存，按日期查閱出勤記錄",
    attendanceAlt: "班主任按座位點名、出席及缺席統計與自動保存狀態（虛構 Demo 資料）",
    missingTab: "欠交跟進",
    missingTitle: "不同科目的欠交，<br/>放在同一處跟進。",
    missingDescription:
      "按科目和項目記下欠交學生，集中處理班主任需要跟進的名單。用班號或座位選人，學生補交後再更新記錄，清楚知道還有誰未完成。",
    missingPoint1: "按科目與項目整理欠交名單",
    missingPoint2: "用班號名單或座位選擇學生",
    missingPoint3: "補交後更新名單，跟進未完成項目",
    missingAlt: "班主任按科目記錄欠交學生及當日欠交項目（虛構 Demo 資料）",
    homeroomTab: "班務事項",
    homeroomTitle: "班務有地方記，<br/>跟進有紀錄可查。",
    homeroomDescription:
      "回條、帶備物品和日常提醒，用備忘整理需要跟進的學生；發生了甚麼、之後怎樣處理，再記入班務記事簿。把日常待辦與班務記錄放在一起，減少來回翻找。",
    homeroomPoint1: "日常備忘整理回條及帶備事項",
    homeroomPoint2: "記下班務事件與跟進內容",
    homeroomPoint3: "查閱已有備忘與班務記事",
    homeroomAlt: "最新版班主任班務記事簿與班主任工具（虛構 Demo 資料）",
    dutiesTab: "學生職務",
    dutiesTitle: "誰負責甚麼，<br/>學生職務清楚安排。",
    dutiesDescription:
      "把科長、班長與其他學生職務集中安排，直接從學生名單選擇負責人。按班級需要加入科目或職務，調整安排後保存，不用再翻找另一份分工表。",
    dutiesPoint1: "安排各科科長及學生職務",
    dutiesPoint2: "按需要加入自訂科目與職務",
    dutiesPoint3: "直接選擇學生，分工自動保存",
    dutiesAlt: "科長、班長及其他學生職務的學生安排（虛構 Demo 資料）",
    studentsTab: "學生記錄",
    studentsTitle: "由全班概況，<br/>查到個別學生的記錄。",
    studentsDescription:
      "出勤與欠交記錄彙整成班級概況，方便找到需要留意的學生。再按姓名或班號查閱個別記錄，了解日期與事項，為後續跟進作準備。",
    studentsPoint1: "查看全班出勤與欠交摘要",
    studentsPoint2: "按姓名或班號查閱學生記錄",
    studentsPoint3: "查閱出勤、欠交及最近記錄",
    studentsAlt: "班主任學生名單、班級概況及欠交科目分布（虛構 Demo 資料）",
    seatingTab: "座位表",
    seatingTitle: "編排全班座位，<br/>點名沿用同一張座位表。",
    seatingDescription:
      "按班級需要調整座位、行列與走廊，切換教師或學生視角。保存後，點名沿用座位安排，方便按位置確認出勤。",
    seatingPoint1: "點選或拖放學生，安排及交換座位",
    seatingPoint2: "調整行列、走廊及教師／學生視角",
    seatingPoint3: "座位安排自動保存，點名接著用",
    seatingAlt: "班主任座位表編排、行列與視角控制及班級座位安排（虛構 Demo 資料）",
    toolsKicker: "兩種角色，一套共用工具",
    toolsTitle: "名單、座位、日程，接著用。",
    toolSeatingSymbol: "座",
    toolGroupsSymbol: "組",
    toolCalendarSymbol: "曆",
    toolHistorySymbol: "生",
    toolImportSymbol: "入",
    toolExportSymbol: "出",
    localLabel: "LOCAL",
    accountLabel: "ACCOUNT",
    demoChoiceLabel: "01 / DEMO",
    toolSeating: "座位表",
    toolSeatingDescription: "課堂記錄與點名，沿用同一份座位安排。",
    toolGroups: "抽人與分組",
    toolGroupsDescription: "課堂上抽選學生、安排小組，沿用班級名單。",
    toolCalendar: "日曆與事項",
    toolCalendarDescription: "查閱班別日程，安排功課、評核和班務事項。",
    toolHistory: "學生記錄",
    toolHistoryDescription: "由全班概況走到個別學生的成績、逐日記錄及備註。",
    toolImport: "Excel／CSV 匯入",
    toolImportDescription: "從 Excel 貼上學生名單，或匯入 Excel／CSV；核對內容後即可加入班級。",
    toolExport: "記錄匯出",
    toolExportDescription: "按需要篩選，再匯出 Excel、CSV、PDF 或 JSON。",
    interactionKicker: "先感受一下",
    interactionTitle: "學生回答了。<br/>試著記一下。",
    interactionMobileTitle: "看看課堂記錄，<br/>怎樣連起來。",
    interactionDescription: "點選座位卡上的虛構學生，看看回答次數怎樣更新，再試試重設。",
    interactionMobile: "操作示範請改用電腦或 iPad；手機可閱讀平台介紹。",
    dataTeaserKicker: "資料由你保管",
    dataTeaserTitle: "學生紀錄，<br/>留在自己的裝置。",
    dataTeaserDescription:
      "Free Trial 的學生名單與課堂紀錄保存在目前裝置的瀏覽器，不會自動上傳至雲端。登入是檢查使用權限，不代表跨裝置同步。",
    dataTeaserDetail: "目前只支援一部裝置、同一個瀏覽器。請定期下載加密備份。",
    dataLink: "了解保存與備份",
    faqKicker: "開始之前",
    faqTitle: "你可能想先知道。",
    faqMore: "查看完整 FAQ 與開始流程",
    faqDemoQuestion: "Demo 和 Free Trial 有甚麼分別？",
    faqDemoAnswer:
      "Demo 免登入，使用虛構班別和學生資料；重新載入會重設。Free Trial 使用 Google 登入，可以建立自己的班別及記錄，資料保存在目前裝置的瀏覽器。",
    faqDeviceQuestion: "可以用手機嗎？支援甚麼裝置？",
    faqDeviceAnswer:
      "課堂工作台適合在電腦或 iPad 使用；手機可閱讀網站介紹和使用指南。使用 iPad 時，建議先把課序加入主畫面，之後固定從同一個圖示開啟。已有記錄的用戶，請先閱讀 iPad 使用指南的資料提醒。",
    faqStorageQuestion: "學生資料會上傳到雲端嗎？",
    faqStorageAnswer:
      "目前 Free Trial 的學生名單及課堂紀錄保存在裝置的瀏覽器，不會自動上傳。Google 登入及使用權限檢查仍需網絡，帳戶與授權服務會處理必要的帳戶資訊、IP 和時間。完整安排見資料與備份頁及私隱政策。",
    faqSyncQuestion: "登入同一帳戶，可以在另一部裝置看到紀錄嗎？",
    faqSyncAnswer:
      "不會自動出現。目前只支援一部裝置、同一個瀏覽器，登入不會同步學生或課堂資料。換裝置前請先下載加密備份，再在新環境還原；還原會取代該環境現有資料。",
    faqPriceQuestion: "現在要付款嗎？",
    faqPriceAnswer: "目前提供 Free Trial，毋須信用卡。收費版、價格及相關政策尚未公布；推出前會另行說明。",
    faqInternetQuestion: "一定要連線才能使用嗎？",
    faqInternetAnswer:
      "Free Trial 啟動及回到前景時需要連線檢查使用權限。網絡故障時，上次成功檢查起 10 分鐘內可繼續保存；之後轉為唯讀，仍可查閱、匯出及下載加密備份。權限到期或撤銷會即時轉為唯讀。",
    faqBackupQuestion: "怎樣備份？清除瀏覽器會怎樣？",
    faqBackupAnswer:
      "請定期下載加密備份，分開保管備份檔和密碼。清除網站資料、移除瀏覽器資料或更換瀏覽器，可能令本機紀錄無法使用。備份不是自動雲端同步；還原前要確認，因為它會取代現有資料。",
    faqImportQuestion: "可以沿用 Excel 紀錄嗎？",
    faqImportAnswer:
      "可以匯入平台支援的 Excel 或 CSV 紀錄，先預覽、對應欄位及檢查資料，再確認匯入；並非所有檔案都能原樣匯入。學生及課堂記錄亦可按需要篩選匯出。",
    faqRealQuestion: "Free Trial 可以用於真實課堂嗎？",
    faqRealAnswer:
      "可以，但你須確認符合學校規定及適用的資料保障要求，並自行管理裝置、存取權限和備份。學生名單及課堂紀錄由你在本機保管。",
    faqQuizQuestion: "有網上小測、AI 出題或雲端同步嗎？",
    faqQuizAnswer: "這些功能目前未開放。此網站展示的是目前可用的課堂、課業與班務工具；日後推出新功能時會更新介紹。",
    ctaKicker: "由一個班級開始",
    ctaTitle: "先試操作，再用在自己的課堂。",
    ctaDescription: "Demo 已備好虛構名單和記錄。毋須先整理自己的資料，就能看看是否適合你的工作。",
    footerDescription: "老師的課堂與班務工作台。",
    footerDeviceNote: "工作台適用於電腦及 iPad；手機可閱讀網站介紹。",
    dataPageTitle: "課序｜資料與備份",
    dataPageDescription: "了解課序 Free Trial 的本機資料保存、帳戶連線、加密備份與單裝置安排。",
    dataPageKicker: "資料與備份",
    dataPageTitleText: "紀錄留在本機。<br/><strong>保存方式，先說清楚。</strong>",
    dataPageLead: "課序目前提供本機版 Free Trial。學生與課堂紀錄由你保管；帳戶登入和課堂資料保存，是兩件不同的事。",
    dataFlowDevice: "你的裝置與瀏覽器",
    dataFlowRecords: "學生名單・課堂・課業・班務紀錄",
    dataFlowBackup: "手動下載加密備份",
    dataFlowAccount: "帳戶及使用權限",
    dataFlowAccountDetail: "Google 登入與連線檢查；不傳學生及課堂紀錄",
    dataFlowCaption: "目前 Free Trial 的保存方式",
    dataAccountTitle: "登入需要網絡，課堂資料留在本機。",
    dataAccountDescription:
      "Google 處理登入；帳戶及使用權限服務處理必要的授權資訊。這些連線不會把學生名單或課堂紀錄一起上傳。服務仍會接收 IP 及連線時間。",
    dataChecklistTitle: "換裝置或清除資料之前",
    dataChecklist1: "先下載最新加密備份，確認檔案已保存。",
    dataChecklist2: "分開保管備份檔及密碼，避免只放在同一部裝置。",
    dataChecklist3: "還原前確認目標環境；還原會取代現有本機資料。",
    dataReadOnlyTitle: "連線失敗時，先保留紀錄。",
    dataReadOnlyDescription:
      "連線或授權問題不會自動刪除本機資料。唯讀期間仍可查閱、匯出及下載加密備份，方便你保留和處理已記下的內容。",
    policyLink: "閱讀完整私隱政策",
    syncPageTitle: "課序｜跨裝置同步",
    syncPageDescriptionAvailable:
      "Free Trial 用戶可自選 Google Drive 同步，首次連接及 QR 配對後，在自己的電腦和 iPad 接續班別與課堂記錄。",
    syncPageDescription: "跨裝置同步努力開發中。課序目前只支援一部裝置、同一個瀏覽器；了解目前的使用方式與開發方向。",
    syncStatusAvailable: "Free Trial 自選功能",
    syncLeadAvailable: "在電腦備課、用 iPad 上課，接續同一份班別與課堂記錄。",
    syncCurrentTitleAvailable: "首次設定，之後自動同步。",
    syncCurrentDescriptionAvailable:
      "自行選擇開啟 Google Drive 同步，其他私人裝置首次掃 QR 配對。課序開著並連網時，保存後自動同步。",
    syncPlanTitleAvailable: "由自己的 Drive 保存加密資料。",
    syncPlanDescriptionAvailable:
      "同步資料先在裝置加密，再存到你授權的 Drive 應用程式空間，不讀取其他 Drive 檔案。換裝置前先等同步完成，並保留獨立備份。",
    syncStatus: "努力開發中",
    syncLead: "讓老師工作更方便，是課序最重視的事。",
    syncCurrentTitle: "目前只支援一部裝置",
    syncCurrentDescription:
      "請在同一部裝置、同一個瀏覽器使用。課堂與班務紀錄保存在這個瀏覽器內；即使登入同一帳戶，也不會自動同步到其他裝置。",
    syncDataLink: "了解目前的資料保存與備份",
    syncPlanTitle: "讓工作在不同裝置接續",
    syncPlanDescription:
      "我們明白，老師需要在電腦與 iPad 之間靈活處理工作。我們正努力開發跨裝置同步，會盡快推出，讓你在不同裝置上接續處理課堂與班務。",
    guidePageTitle: "課序｜使用指南",
    guidePageDescription: "由 Demo 到 Free Trial 的開始流程，以及裝置、備份、匯入、連線及收費常見問題。",
    guideKicker: "使用指南",
    guideTitle: "從一項日常工作，<br/><strong>開始用課序。</strong>",
    guideLead: "先看看怎樣記，再決定怎樣用。你可以由 Demo 熟悉操作，也可以直接登入 Free Trial 建立自己的班級。",
    guideStepsTitle: "自己的班級，這樣開始。",
    guideStep1Title: "設定你的班別",
    guideStep1Description: "用 Google 登入，設定班主任班及任教班別。",
    guideStep2Title: "匯入學生名單",
    guideStep2Description: "先核對名單，再匯入你的班級。",
    guideStep3Title: "設定座位表",
    guideStep3Description: "排好座位，就可以開始記錄課堂與班務。",
    faqAllTitle: "常見問題",
  },
  classSetupStatus: {
    notImported: "未匯入名單",
    needsSeating: "待設定座位",
    complete: "已完成設定",
    cardRegion: "{{name}}設定狀態",
    studentCount: "{{count}} 位學生",
    studentCount_one: "{{count}} 位學生",
    studentCount_other: "{{count}} 位學生",
    classEntry: "{{name}} {{count}} 位學生",
    classEntry_one: "{{name}} {{count}} 位學生",
    classEntry_other: "{{name}} {{count}} 位學生",
    importRoster: "匯入名單",
    arrangeSeating: "設定座位",
    classAction: "{{name}}：{{action}}",
    manageClasses: "管理班別",
    addClass: "新增班別",
    emptyRegion: "班別設定",
    emptyTitle: "{{name}}尚未匯入學生名單",
    emptyDescription: "先匯入這一班的名單，就可以開始使用課堂與班務工具。",
    followUpRegion: "接續設定",
    classComplete: "{{name}}已完成設定",
    tutorialComplete: "{{name}}的基本教學已完成",
    continueCurrentSeating: "名單已匯入，可以繼續為其餘學生安排座位。",
    otherClasses: "其他班別還有：",
    missingRosterCount: "{{count}} 班未匯入名單",
    missingRosterCount_one: "{{count}} 班未匯入名單",
    missingRosterCount_other: "{{count}} 班未匯入名單",
    missingSeatingCount: "{{count}} 班待設定座位",
    missingSeatingCount_one: "{{count}} 班待設定座位",
    missingSeatingCount_other: "{{count}} 班待設定座位",
    canSetUpLater: "。可繼續設定，也可以稍後處理。",
    noOtherClasses: "可以開始使用了；日後可在「管理班別」新增班別。",
    nextClass: "設定下一班",
    startUsing: "開始使用",
    waitForSave: "請等候目前的改動保存完成。",
    leaveUnsaved: "尚有未保存的改動，要放棄並切換班別或離開目前畫面嗎？",
  },
  classSetup: {
    title: "設定我的班別",
    trial: "Free Trial · 設定會保存在此瀏覽器",
    intro: "告訴我們你負責哪些班別，幫你安排日常工作入口。",
    steps: ["班主任班", "任教班別", "確認入口"],
    stepCount: "第 {{step}} 步，共 3 步",
    homeTitle: "你的班主任班是哪一班？",
    homeIntro: "班主任班只需填一班；如果本學年沒有擔任班主任，選擇下方選項。",
    hasHome: "我是班主任",
    noHome: "本學年不是班主任",
    homeLabel: "班主任班別",
    homePlaceholder: "例如：3C",
    teachingTitle: "你任教哪些班別及科目？",
    teachingIntro: "逐班加入即可。已填過的班別可以直接選取，其餘班別稍後也能新增。",
    classLabel: "班別",
    subjectLabel: "任教科目",
    rowClass: "第 {{row}} 項班別",
    rowSubject: "第 {{row}} 項任教科目",
    rowRemove: "移除第 {{row}} 項",
    classPlaceholder: "例如：2A",
    subjectPlaceholder: "例如：公民科",
    addTeaching: "＋ 加入任教班別",
    noTeaching: "目前沒有任教班別",
    sharedNote: "同一班的名單及座位表會自動共用，科目記錄各自保存。",
    reviewTitle: "這是你的班別入口",
    reviewIntro: "首頁會分成兩區，方便你按當下工作直接進入。",
    homeroomGroup: "班主任班",
    teachingGroup: "任教班別",
    homeTools: "點名 · 欠交 · 班務",
    teachingTools: "課堂表現 · 課業 · 成績",
    noHomeroom: "本學年沒有班主任班",
    noTeachingSummary: "暫未加入任教班別",
    nextSetup: "下一步：匯入學生名單",
    nextSetupHint: "每班只需匯入一次。先進入班別，再到後台管理匯入名單及編排座位；現有班別和記錄會保留。",
    next: "下一步",
    back: "上一步",
    finish: "確認並開始使用",
    saving: "正在保存…",
    saveFailed: "未能保存班別，請重試。",
    draftSaving: "正在保存草稿…",
    draftSaved: "草稿已自動保存",
    draftSaveFailed: "此瀏覽器未能保存草稿；重新整理前請先完成設定。",
    manualSetup: "逐班新增",
    openSetup: "設定我的班別",
    errorHome: "請先填寫你的班主任班別。",
    errors: {
      empty: "請至少加入一個班主任班或任教班別。",
      teachingChoice: "請填寫任教班別及科目，或勾選「目前沒有任教班別」。",
      incomplete: "請填齊每項班別及任教科目，或移除未完成的一項。",
      duplicate: "同一班別及科目只需加入一次，請移除重複的一項。",
      existingHomeroom: "你已有班主任班。請使用現有班別；如要更換，請先在後台停用原有班別。",
      ambiguous: "有多個同名班別，請先在後台核對名稱，以免連結錯誤名單。",
    },
  },
  randomGroups: {
    mode: "分組方式",
    bySize: "每組人數",
    byCount: "組數",
  },
  responseDraw: {
    pick: "抽學生",
    again: "再抽一位",
    remaining: "尚餘 {{remaining}} / {{total}} 人",
    result: "座位表抽選結果",
    student: "{{number}} 號 {{name}}",
    selected: "抽中",
    unseated: "未編座位",
    record: "記一次回應",
    recorded: "已記錄回應",
  },
  drawHistory: {
    clear: "清空歷史",
    clearConfirm: "清空「{{name}}」全部 {{count}} 次抽選歷史？此操作無法復原，本輪已抽名單及抽選設定會保留。",
    clearConfirm_one: "清空「{{name}}」全部 {{count}} 次抽選歷史？此操作無法復原，本輪已抽名單及抽選設定會保留。",
    clearConfirm_other: "清空「{{name}}」全部 {{count}} 次抽選歷史？此操作無法復原，本輪已抽名單及抽選設定會保留。",
    clearFailed: "未能確認清空結果，請重新整理後核對記錄。",
    resetMode: "名單重設",
    dailyMode: "每天自動重設",
    completeMode: "抽完名單才重設",
    title: "抽選歷史",
    count: "共 {{count}} 次",
    count_one: "共 {{count}} 次",
    count_other: "共 {{count}} 次",
    description: "保存每次抽選的結果及香港時間；重設名單後仍會保留。",
    time: "抽選時間（香港）",
    number: "學號",
    name: "姓名",
    empty: "尚未有抽選記錄，完成抽選後會自動保存。",
    pagination: "抽選歷史分頁",
    previous: "上一頁",
    next: "下一頁",
    page: "第 {{page}} / {{pages}} 頁",
    saveFailed: "未能儲存抽選結果，請重試。",
  },
  studentPagination: {
    view: "點名方式",
    list: "班號名單",
    seating: "座位表",
    records: "學生記錄分頁",
    directory: "學生名單分頁",
    routine: "日常事項學生分頁",
    memos: "備忘學生分頁",
    unseated: "未編座位學生分頁",
    submissions: "測驗提交分頁",
    previous: "上一頁",
    next: "下一頁",
    page: "第 {{page}} 頁",
    position: "第 {{page}} / {{pages}} 頁",
  },
  attendanceRegister: {
    present: "出席",
    absent: "缺席",
    studentAction: "{{number}} 號 {{name}}{{gender}}：{{current}}，點擊改為{{next}}",
    saving: "保存中…",
    saved: "已保存",
    ready: "點選即保存",
    failed: "點名未能保存。",
    savedDate: "{{date}} 點名已保存",
  },
  quickBackup: {
    action: "備份",
    title: "備份最新資料",
    demoTitle: "備份示範資料",
    demoFilename: "課序-示範資料備份",
    password: "備份密碼（至少 12 字元）",
    sessionHint: "還原時需要此密碼。此頁面開啟期間，再按「備份」即可直接下載最新資料。",
    download: "立即備份",
    busy: "備份中…",
    cancel: "取消",
    cancelBackup: "取消備份",
    downloaded: "最新資料的加密備份已下載。",
    demoDownloaded: "虛構示範資料的加密備份已下載。",
    canceled: "備份已取消，現有資料沒有更改。",
    failed: "備份失敗，請再試一次。",
    tooLarge: "備份檔超過目前支援的 100 MB 上限。",
    saveFirst: "請先保存目前的修改，待保存完成後再備份。",
  },
  backupFolder: {
    chooseAction: "選擇資料夾並儲存加密備份",
    writing: "正在將加密備份寫入所選資料夾…",
    explanation:
      "可選擇電腦上的同步資料夾，例如 iCloud Drive 或 Proton Drive。雲端上傳由你已安裝的同步程式處理，請自行確認同步狀態。",
    newFile: "每次另建新檔，保留舊備份；本產品不記住資料夾權限。",
    unsupported: "這個瀏覽器未支援直接選擇資料夾。請先下載加密備份，再自行移到所選的同步資料夾。",
    saved: "已將加密備份儲存到「{{folder}}」：{{filename}}。請確認同步程式已完成上傳，並分開保管密碼。",
    canceled: "已取消。現有課堂資料及舊備份沒有更改；若已開始寫入，請檢查資料夾內新建的備份檔。",
    permission: "未能取得資料夾寫入權限。請再次按選擇資料夾，或改用下載加密備份。",
    collision: "未能建立新的備份檔名。舊檔沒有被覆蓋，請重新選擇資料夾再試。",
    invalid: "備份格式或大小不符合要求，未寫入資料夾。",
    write: "未能完成備份寫入或核對。請檢查資料夾空間及新建檔案，再重新選擇資料夾；舊備份沒有被覆蓋。",
  },
  cloudMigration: {
    title: "匯入舊版資料",
    intro: "選擇舊版課堂工作區匯出的 JSON 檔案（最多 50 MB）。先在此裝置檢查，不會連接或更新舊版伺服器。",
    archive: "舊版小測資料會封存並包含於加密備份；本版尚未提供小測操作。",
    file: "舊版 JSON 匯出檔",
    check: "檢查匯出檔",
    working: "正在檢查或匯入…",
    previewTitle: "匯入前核對",
    source: "來源工作區",
    target: "本地工作區",
    exportedAt: "匯出日期",
    checksum: "檔案指紋（SHA-256）",
    counts: "資料筆數比較",
    collection: "資料類別",
    current: "目前本地",
    incoming: "匯出檔",
    replaceNotice:
      "匯入會取代此瀏覽器目前的資料，保留每筆記錄的 ID 及關聯，並把工作區 ID 映射至此瀏覽器。工具顯示設定和本地授權設定保持。請先下載目前資料的加密備份。",
    acknowledge: "我已備份目前資料，並確認把舊版工作區映射至此瀏覽器，取代目前資料。",
    import: "確認取代並匯入",
    confirm: "確定以這份舊版匯出檔取代此瀏覽器的目前資料？請先保留目前資料的加密備份。",
    success: "舊版資料已匯入。請核對班別及記錄，並下載新的加密備份。",
    failed: "匯入失敗；目前資料已保留。",
    tooLarge: "匯出檔超過 50 MB 上限。",
    collections: {
      classes: "班別",
      students: "學生",
      dailyRecords: "課堂回應及欠帶書簿",
      homeworkAssignments: "課業事項",
      homeworkRecords: "課業學生記錄",
      calendarEvents: "日程",
      homeroomRecords: "班級記錄",
      attendanceRecords: "點名",
      homeroomHomeworkRecords: "班主任欠交記錄",
      studentRoutineItems: "日常事項",
      seatingCharts: "座位表",
      quizzes: "封存題組",
      quizSessions: "封存小測場次",
      quizResponses: "封存作答",
      quizAttempts: "封存作答暫存",
      personalNotes: "個人筆記",
      personalNotePages: "手寫頁",
    },
  },
  rosterAdmin: {
    deleteEmptyClass: "刪除空班別",
    deleteEmptyNote: "刪除後無法復原。只可刪除沒有學生、記錄及共用名單關聯的班別。",
    deleteEmptyName: "輸入班別名稱以確認",
    deletingEmpty: "刪除中…",
    emptyBlocked: "此班別有學生、記錄或共用名單關聯，未有刪除。",
    emptyChanged: "班別名稱已變更，請重新選擇及確認。",
    emptyFailed: "未能刪除班別，請稍後再試。",
    sourceClass: "原班別",
    invalidSourceClass: "請填寫有效的原班別（最多 40 個字元）。",
    addStudentEntry: "新增個別學生",
    addStudentHint: "插班生／臨時補加",
    studentCount: "{{count}} 位學生",
    addStudent: "新增學生",
    adding: "新增中…",
    addClass: "新增班別",
    chooseClass: "選擇班別",
    number: "班號",
    name: "姓名",
    gender: "性別",
    numberLabel: "新增學生班號",
    nameLabel: "新增學生姓名",
    genderLabel: "新增學生性別",
    unspecified: "未填",
    male: "男",
    female: "女",
    other: "其他",
    added: "已新增 {{number}} 號 {{name}}",
    duplicateNumber: "班號 {{number}} 已有學生，請使用其他班號。",
    invalidNumber: "班號須為 1–999 的整數。",
    missingName: "請填寫學生姓名。",
    invalidGender: "請重新選擇性別。",
    invalidClass: "班別已變更或停用，請重新選擇。",
    saveFailed: "未能新增學生，請保留輸入並稍後再試。",
  },
  adminRecords: {
    importTitle: "記錄匯入",
    exportTitle: "記錄匯出",
    intro: "集中匯出跨班、整學期或多種記錄。選擇範圍及 Excel／CSV／PDF／JSON 後下載；完整資料備份請到「本地資料」。",
    chooseClasses: "1. 選擇班別",
    roles: { teaching: "任教班別", homeroom: "班主任班別" },
    role: "班別類型",
    allRoleClasses: "全選此類班別",
    clearClasses: "清除班別",
    noClasses: "尚未建立這類班別。",
    noSelectedClasses: "尚未選擇班別",
    noSelectedRecords: "尚未選擇記錄",
    recordsStep: "2. 選擇記錄",
    roleRecords: "{{role}}記錄",
    sharedRecords: "共用資料",
    dateStep: "3. 日期範圍",
    summary: "這次匯出",
    selectedClasses: "已選班別 · {{count}} 班",
    selectedRecords: "已選記錄 · {{count}} 類",
    selectedDates: "記錄日期",
    fromOnly: "{{date}} 起",
    toOnly: "截至 {{date}}",
    dateRange: "{{from}} 至 {{to}}",
    downloadSelection: "匯出 {{format}} · {{classes}} 班／{{records}} 類",
    formatHints: { xlsx: "整理與分析", csv: "通用表格", pdf: "閱讀與列印", json: "資料交換" },
    descriptions: {
      roster: "學號、姓名及學生資料",
      answers: "日期、學生回應及備註",
      materials: "日期、欠帶書簿狀態及備註",
      coursework: "課業、繳交狀態及成績",
      attendance: "日期、出席狀態及備註",
      missingHomework: "科目、課業及欠交狀態",
      routine: "日常事項及學生記錄",
      affairs: "班務事項及跟進記錄",
      duties: "目前職務及負責學生",
      seating: "目前座位及學生安排",
      calendar: "日期、事項及備註",
    },
    scope: "匯出範圍",
    class: "匯出班別",
    allClasses: "所有班別",
    term: "匯出學期",
    allDates: "全部日期",
    chooseRecords: "選擇匯出記錄",
    all: "全選記錄",
    clear: "清除選擇",
    format: "檔案格式",
    download: "匯出 {{format}}",
    working: "正在匯出…",
    downloaded: "匯出檔案已下載。",
    failed: "匯出未能完成，請重試。",
    fileHint:
      "Excel 按班別及記錄類型分成工作表；CSV 合併所有表格並標示來源表格；PDF 合併成一份文件；JSON 保留所有表格的欄位及資料。名單、座位及目前分工不按日期篩選。JSON 記錄匯出不適用於完整備份還原。",
    preview: "匯出內容預覽",
    previewHint: "預覽每頁最多 10 筆；下載包含所選範圍的全部記錄。",
    emptyRecords: "所選範圍未有這類記錄。",
    kinds: {
      roster: "學生名單",
      answers: "課堂回應",
      materials: "欠帶書簿",
      coursework: "課業與成績",
      attendance: "點名記錄",
      missingHomework: "班主任欠交",
      routine: "日常事項",
      affairs: "班務事項",
      duties: "學生職務",
      seating: "座位表",
      calendar: "日曆事項",
    },
  },
  terms: {
    title: "學期總覽",
    details: "學生詳細記錄",
    settingsTitle: "學年與學期",
    settingsIntro: "每學年設定一次，所有班別共用。學期日期可按學校校曆調整。",
    scope: "記錄學期",
    all: "全部日期",
    configure: "設定學期",
    manage: "管理學期",
    noTerms: "尚未設定學期。到後台設定日期後，即可按學期查看和比較學生表現。",
    range: "{{start}} 至 {{end}}（包含首尾日）",
    gap: "所選學期以外的記錄可在「全部日期」查看。",
    settingsEyebrow: "全班共用設定",
    schoolYear: "學年",
    name: "學期名稱",
    start: "開始日期",
    end: "結束日期",
    addYear: "新增學年",
    setupYear: "設定學年",
    closeSetup: "關閉學年設定",
    setupIntro: "學校一年分多少個學期？選擇後，按學校校曆設定各學期的分界日期。",
    termCount: "學期數目",
    templatePreview: "學期日期範本",
    templateStart: "{{name}}開始日期",
    templateEnd: "{{name}}結束日期",
    setupLater: "稍後設定",
    createTerms: "建立學期",
    yearStart: "學年開始年份",
    twoTerms: "兩學期（上、下學期）",
    threeTerms: "三學期",
    academicYearRange: "{{year}}–{{nextYear}} 學年：{{year}} 年 9 月 1 日至 {{nextYear}} 年 8 月 31 日。",
    addTerm: "＋ 新增學期",
    remove: "移除學期 {{name}}",
    save: "保存學期設定",
    saving: "正在保存…",
    saved: "學期設定已保存",
    reset: "還原未保存修改",
    defaults: "修改學期結束日，下一學期會自動從翌日開始。整個學年由 9 月 1 日至翌年 8 月 31 日；保存後毋須重複設定。",
    removeNote: "移除或更改學期只會改變統計範圍，學生記錄仍然保留。",
    dateRule:
      "日常記錄按當日日期、功課及測驗按到期日、日常事項按事項日期（舊資料使用建立日期）歸屬。補交和補分仍屬原學期。",
    errors: {
      required: "請填妥學年及學期名稱。",
      invalidDate: "請填寫有效的開始及結束日期。",
      order: "結束日期不可早於開始日期。",
      overlap: "學期日期不可重疊，上一學期的最後一天須早於下一學期的第一天。",
      duplicate: "學期識別碼重複，請重新加入該學期。",
      yearExists: "這個學年已存在，可在下方修改日期。",
      yearInvalid: "請輸入 1900 至 9998 之間的學年開始年份。",
      cloud: "學期設定目前提供於 Demo 及本地版本。",
      save: "未能保存學期設定，請再試一次。",
    },
    overviewIntro: "逐位學生查看本學期，並對照另一學期。按姓名展開各學期及本學期每月記錄。",
    selected: "查看學期",
    compare: "比較學期",
    noCompare: "暫不比較",
    compared: "{{current}} 對照 {{previous}}",
    student: "學生",
    search: "搜尋學期總覽學生",
    searchPlaceholder: "班號或姓名",
    sort: "學期總覽排序",
    byNumber: "按班號",
    byGrade: "成績變化較大先顯示",
    category: "比較類型",
    homeworkMissing: "欠交比例",
    examMissing: "未應考比例",
    recordMissing: "待跟進比例",
    examCount: "{{tasks}} 項已記錄評估 · 未應考 {{value}} 次",
    recordCount: "{{tasks}} 項已記錄事項 · 待跟進 {{value}} 次",
    examFollowup: "本學期有未應考",
    recordFollowup: "本學期有待跟進記錄",
    byResponse: "回應增加較多先顯示",
    byFollowup: "需跟進先顯示",
    export: "匯出學期總覽 CSV",
    expand: "查看 {{number}} 號 {{name}} 的學期變化",
    disabled: "已停用",
    empty: "此班尚未有學生。",
    missing: "未有資料",
    noBaseline: "比較學期未有資料",
    noCurrent: "本學期未有資料",
    same: "沒有變化",
    timesUnit: "次",
    up: "增加 {{value}} {{unit}}",
    down: "減少 {{value}} {{unit}}",
    points: "百分點",
    perDayUnit: "次／記錄日",
    perTen: "{{value}} 次／10項",
    perTenUnit: "次／10項",
    perDay: "{{value}} 次／日",
    percent: "{{value}}%",
    times: "{{value}} 次",
    grade: "平均成績",
    answers: "課堂回應",
    materials: "欠帶書簿比例",
    attendance: "出席率",
    subjectHomework: "任教欠交比例",
    homeroomHomework: "班主任欠交",
    routine: "日常事項例外",
    routineDate: "事項日期",
    gradeCount: "{{value}} 份有效分數",
    dailyCount: "{{days}} 個記錄日 · 共 {{value}} 次",
    attendanceCount: "{{days}} 個點名日 · 缺席 {{absent}} 次 · 遲到 {{late}} 次",
    taskCount: "{{tasks}} 項已記錄課業 · 欠交 {{value}} 次",
    homeroomCount: "{{tasks}} 項班級記錄 · 欠交 {{value}} 次",
    studentsCount: "{{value}} 位學生",
    gradeUp: "成績上升",
    responseUp: "回應增加",
    courseworkNotes:
      "平均成績只計有分數及滿分的評估，每筆轉為百分比後等權平均；欠交率按已登記狀態的事項計算。不同學期的評估內容及權重可能不同，分數差距只作跟進參考。",
    followup: "本學期有課業欠交",
    homeroomFollowup: "本學期需跟進",
    change: "變化",
    comparable: "有成績可比較",
    history: "各學期表現",
    monthly: "本學期逐月變化",
    month: "月份",
    notes:
      "比較只計已保存資料。成績以有效分數百分比等權平均；回應及欠帶書簿按有記錄日平均，出席率包含遲到。欠交是目前保存的狀態，補交後會更新。",
    homeroomNote:
      "班主任欠交只記錄例外名單，次數按已保存項目計算。日常事項是該日期所屬項目的現有例外狀態，不代表每天的歷史次數。",
    noObservation: "未記錄不等於零；↑／↓ 表示數值增加／減少，不合併為綜合評分。",
    outOfRange: "請選擇所選學期內的日期。",
    unsaved: "尚有未保存的學生記錄。切換學期會收起這些修改，確定切換？",
    busy: "正在保存記錄，請稍候再切換學期。",
    scopeExport: "{{name}} · {{start}} 至 {{end}}",
    detailTitle: "{{number}} 號 {{name}} · 學期變化",
  },
  answerRanking: {
    gold: "金牌",
    silver: "銀牌",
    bronze: "銅牌",
    medalRank: "累計回答排名第 {{rank}} 名（{{medal}}）",
  },
  automaticSave: {
    status: "{{name}}保存狀態",
    error: "{{name}}保存錯誤",
    ready: "填妥資料後自動保存",
    incomplete: "資料未完整，尚未保存",
    saving: "正在保存…",
    saved: "已保存",
    failed: "未能保存",
    retained: "修改仍保留在畫面上，請重試。",
    retry: "重試保存",
    discard: "尚有未保存的修改，要放棄並切換記錄嗎？",
  },
  keyboard: {
    saveDuties: "保存分工",
    addSecondMonitor: "{{subject}}加第二位科長",
    removeSecondMonitor: "{{subject}}移除第二位科長",
    addSecond: "＋ 加第二位",
    removeSecond: "移除第二位",
    studentActiveLabel: "{{number}} 號 {{name}}：啟用狀態",
    studentEnabled: "{{name}}已啟用",
    studentDisabled: "{{name}}已停用",
    studentUpdateFailed: "未能更新學生狀態，請稍後再試。",
    calendarStart: "第 {{number}} 項開始日期",
    calendarEnd: "第 {{number}} 項結束日期",
    calendarTitle: "第 {{number}} 項事項名稱",
    calendarCategory: "第 {{number}} 項類別",
    calendarNote: "第 {{number}} 項備註",
    calendarSource: "查看第 {{number}} 項來源文字",
    feedbackSubmitting: "正在提交回饋，請稍候…",
    deleteStudent: "永久刪除 {{number}} 號 {{name}} 的所有資料",
    decreaseAnswer: "{{number}} 號 {{name}}：回答次數減一",
    studentSubmission: "{{number}} 號 {{name}}：繳交狀態",
    studentScore: "{{number}} 號 {{name}}：分數",
    emptySeat: "第 {{row}} 行第 {{column}} 列：空位",
    emptySeatSelected: "第 {{row}} 行第 {{column}} 列：空位，放置已選學生",
    saveTopGroup: "頁首保存操作",
    saveBottomGroup: "頁尾保存操作",
    saveToday: "保存今日記錄",
    recordSaving: "正在保存…",
    recordSaved: "課堂記錄已保存",
    recordSaveToast: "今天的學生記錄已保存",
    recordUnsaved: "尚未保存修改",
    recordReady: "可以開始記錄",
    recordSaveFailed: "未能保存課堂記錄。",
    recordDraftRetained: "修改仍保留在畫面上，請重試。",
    recordSaveStatus: "課堂記錄保存狀態",
    recordRetry: "重試保存",
    recordSaveError: "課堂記錄保存錯誤",
    answersRegion: "回答問題記錄",
    materialsRegion: "欠帶書簿記錄",
    assignmentEditor: "{{title}}：學生記錄",
    assignmentSaveStatus: "課業學生記錄保存狀態",
    assignmentSaveError: "課業學生記錄保存錯誤",
    saveAssignment: "保存學生記錄",
    localDataRegion: "本地資料及備份",
    backupDownloadAction: "下載加密備份",
    backupRestoreAction: "還原並取代現有資料",
    backupProgressStatus: "備份處理進度",
    localDataResult: "本地資料操作結果",
    localDataError: "本地資料操作錯誤",
    storageCapacityStatus: "本機儲存空間提示",
  },
  classroomPerformance: {
    eyebrow: "課堂表現 · 參與及準備",
    title: "課堂表現總覽",
    description: "查看本學期的課堂回應及欠帶書簿記錄；點選學生看逐日詳情。",
    actions: { materials: "記錄欠帶書簿", answers: "記錄課堂回應", terms: "比較學期表現" },
    filters: {
      region: "課堂表現日期篩選",
      customDates: "自訂日期",
      activeRange: "目前日期範圍：{{start}} 至 {{end}}",
      openStart: "最早記錄",
      openEnd: "最新記錄",
      startDate: "開始日期",
      to: "至",
      endDate: "結束日期",
      allDates: "重設日期範圍",
      recordDays: "{{count}} 個有記錄的日子",
      invalidRange: "開始日期不可晚於結束日期，請調整日期範圍。",
    },
    method: "只顯示在校學生的已保存記錄。未記錄不當作 0 次回應；欠帶書簿以日數計，同一天只計一次。",
    empty: {
      title: "這段日期尚未有課堂記錄",
      description: "保存課堂回應或欠帶書簿記錄後，便可在學生清單回看。",
    },
    times: "{{count}} 次",
    times_one: "{{count}} 次",
    times_other: "{{count}} 次",
    students: {
      title: "學生清單",
      tableLabel: "學生課堂記錄",
      historyLabel: "逐日課堂記錄",
      filtersLabel: "學生記錄篩選",
      filters: { all: "全部學生", materials: "曾欠帶書簿", noResponses: "未回應" },
      observedDays: "已記錄 {{count}} 日",
      missingDays: "{{count}} 日",
      missingDays_one: "{{count}} 日",
      missingDays_other: "{{count}} 日",
      latestMissing: "最近 {{date}}",
      latestNote: "最近備註",
      description: "點選學生，查看逐日回應、欠帶書簿及備註。",
      searchLabel: "搜尋課堂表現學生",
      searchPlaceholder: "搜尋姓名或學號",
      sortLabel: "課堂表現排序",
      sort: { number: "按學號", answers: "回應次數由多至少", materials: "欠帶書簿日數由多至少" },
      student: "學生",
      answers: "回應次數",
      missing: "欠帶書簿日數",
      lastResponse: "最近回應",
      view: "查看 {{number}} 號 {{name}}課堂表現",
      details: "{{number}} 號 {{name}}課堂表現明細",
      unrecorded: "尚未有記錄",
      noResponse: "尚未有回應記錄",
      date: "日期",
      response: "回應",
      materials: "書簿準備",
      note: "備註",
      missingMaterials: "欠帶書簿",
      noMissingMaterials: "沒有標記欠帶書簿",
      noHistory: "所選日期內尚未有這位學生的記錄。",
      empty: "沒有符合的學生。",
    },
  },
  gradeOverview: {
    dashboard: {
      title: "課業概覽",
      passPlaceholder: "—",
      followupRegion: "待跟進課業清單",
      openTable: "查看成績總表",
      compareTerms: "跨學期對比",
      pending: "待評分",
      missing: "欠交／未應考",
      unrecorded: "未記錄",
      recordsUnit: "筆",
      attention: "需要跟進",
      taskCount: "{{count}} 份課業",
      taskCount_one: "{{count}} 份課業",
      taskCount_other: "{{count}} 份課業",
      openRecord: "處理{{title}}",
      pendingCount: "{{count}} 人待評分",
      missingCount: "{{count}} 人欠交",
      absentCount: "{{count}} 人未應考",
      unrecordedCount: "{{count}} 人未記錄",
      clear: "目前沒有待跟進項目",
      concerns: "成績需要關注",
      passLine: "合格線",
      invalidPassLine: "合格線須介乎 0 至 100%。",
      noPassLine: "未設定合格線",
      noConcerns: "目前沒有低於合格線的已評分記錄",
      belowCount: "{{count}} 人低於合格線",
      recent: "最近評核",
      average: "平均得分率",
      assessed: "{{count}} 人已評分",
      noMaximum: "未設滿分",
      viewScores: "查看成績",
      noEvaluations: "尚未有測驗或默書記錄",
    },
    table: {
      title: "成績總表",
      term: "查閱學期",
      number: "學號",
      name: "姓名",
      maximum: "滿分 {{score}}",
      scope: "{{students}} 位學生 · {{assignments}} 份課業",
      categoryFilter: "類別",
      backToAll: "返回全部事項",
      region: "成績總表捲動區",
      unscored: "未評分",
      unrecorded: "未記錄",
      noAssignments: "所選範圍尚未有課業",
    },
    compareTerms: "比較學期成績",
    eyebrow: "課業與成績",
    title: "課業成績總覽",
    recordsTitle: "課業記錄總覽",
    description: "按事項比較成績，留意評分進度及需要跟進的學生。",
    recordAction: "記錄課業成績",
    categoryLabel: "成績分類",
    categories: { all: "全部事項", homework: "功課", assessment: "測驗", dictation: "默書" },
    stats: {
      average: "班級平均得分率",
      assignmentCount: "事項總數",
      unscored: "未評分記錄",
      averageNote: "每筆有效成績以百分比等權計算",
      progress: "評分進度",
      progressValue: "{{scored}}<total> / {{possible}}</total>",
      progressNote: "有滿分的事項 · 豁免不計入待評分",
      assessed: "已有成績的學生",
      assessedValue: "{{assessed}}<total> / {{total}}</total>",
      assessedNote: "至少有一筆有效成績",
      missing: "待補交記錄",
      examMissing: "未應考記錄",
      followup: "待跟進記錄",
      missingValue: "{{count}}<unit> 筆</unit>",
      missingNote: "已標記欠交的學生事項",
    },
    method: "只計算已設滿分的有效分數；未評分不當作 0 分。",
    withoutMaximum: " 有 {{count}} 筆分數未設滿分，請到事項記錄補上。",
    assignments: {
      title: "各事項表現",
      progressTitle: "事項評分進度",
      progressRegion: "各事項評分進度",
      progressValue: "{{scored}} / {{possible}} 已評分",
      count: "{{count}} 份事項",
      count_one: "{{count}} 份事項",
      count_other: "{{count}} 份事項",
      description: "依日期排列 · 平均得分率",
      region: "各事項平均分列表",
      empty: "尚未有事項。新增功課、測驗或默書後會在這裡顯示。",
      scored: "{{date}} · {{count}} 位已評分",
      scoredWithoutMaximum: "{{date}} · {{count}} 位已評分 · 未設滿分",
    },
    distribution: {
      title: "學生平均分布",
      description: "按每位學生的有效成績平均分類",
      assessed: "{{count}} 位學生",
      assessed_one: "{{count}} 位學生",
      assessed_other: "{{count}} 位學生",
      students: "{{count}} 位",
      students_one: "{{count}} 位",
      students_other: "{{count}} 位",
      unassessed: "尚未有可比較的成績",
    },
    students: {
      title: "學生表現",
      recordsTitle: "學生記錄",
      description: "點選學生，查看各事項的分數與繳交狀態。",
      searchLabel: "搜尋成績學生",
      searchPlaceholder: "搜尋姓名或學號",
      student: "學生",
      average: "平均得分率",
      scored: "已評分",
      followup: "跟進記錄",
      empty: "沒有符合的學生。",
      view: "查看 {{number}} 號 {{name}}成績",
      details: "{{number}} 號 {{name}}成績明細",
      followupValue: "欠交 {{missing}} · 遲交 {{late}}",
      examFollowupValue: "未應考 {{missing}} · 已補考 {{late}}",
      noEntries: "尚未有事項記錄。",
      unrecorded: "未記錄",
      unscored: "未評分",
      noMaximum: "未設滿分",
      score: "{{score}} / {{maximum}}",
    },
    statuses: { complete: "已繳交", missing: "欠交", late: "遲交", excused: "豁免" },
  },
  auth: {
    localIsolationTitle: "先確認舊資料的歸屬",
    localIsolationChecking: "正在開啟本帳戶的本機資料…",
    localIsolationExplanation:
      "這個瀏覽器有舊版共用資料，現已完整保留，暫不顯示。請由原擁有者確認後移入自己的帳戶；其他帳戶可使用獨立的新工作區。",
    localIsolationCurrent: "目前登入：",
    localIsolationOwnerNotice: "只有這批舊資料的擁有者才可移入。若目前登入的帳戶不正確，請先改用擁有者的 Google 帳戶。",
    localIsolationEmail: "輸入舊資料擁有者的電郵以確認",
    localIsolationClaim: "確認歸屬並保留舊紀錄",
    localIsolationNew: "保留舊資料，使用本帳戶的新資料",
    localIsolationSwitch: "改用其他 Google 帳戶",
    localIsolationVerify: "請先連線確認目前帳戶的使用權限，再移入舊資料。舊紀錄仍完整保留。",
    localIsolationFailed: "未能開啟本機資料，原有資料仍保留。請重新登入後再試。",
    localIsolationRetry: "重新開啟",
    accountSupport: "帳戶與支援",
    supportLink: "支援及帳戶刪除",
    signOut: "登出",
    signOutWaiting: "等待保存完成…",
    signOutBusy: "正在登出…",
    signOutFailed: "未能登出，請檢查連線或重新登入後再試。本機資料及未保存輸入仍保留。",
    signOutSaveFailed: "有紀錄未能保存，請先重試保存，再登出。已輸入的內容仍保留。",
    signOutSaveTimeout: "保存仍未完成，暫未登出。請待保存完成後再試。",
    signOutUnsaved: "仍有未儲存的改動，要放棄這些改動並登出嗎？已保存的本機資料會保留。",
    signedOutNotice: "已登出，這個瀏覽器的課堂資料已保留。",
    brandLabel: "Free Trial 說明",
    eyebrow: "FREE TRIAL",
    heroTitle: "課堂與班務，<br/>整理得更有條理。",
    backHome: "返回首頁",
    localDataNotice: "班級與學生資料只儲存在這個瀏覽器，不會因登入而自動上載雲端。",
    introduction: "帳戶用來識別試用者及分隔本機資料。班級與學生資料儲存在目前瀏覽器，不會因登入而自動上載雲端。",
    benefits: {
      account: "只用 Google 登入，首次使用可建立免費帳戶",
      localData: "重新開啟仍可繼續本機資料",
      backup: "可自行下載加密備份",
    },
    teacherBeta: "教師 Free Trial",
    accessLabel: "Free Trial 使用權限",
    accessReadOnlyTitle: "目前只可讀取",
    accessConnectionTitle: "連線暫時中斷",
    accessConnectionFailed: "未能連接服務，請檢查網絡後重試。",
    accessDataRetained: "已保存資料仍可查閱、匯出及備份；未保存輸入仍保留。",
    accessGraceRemaining: "仍可保存約 {{minutes}} 分鐘，請恢復連線。",
    accessRetry: "重新檢查",
    accessUpdate: "更新此裝置",
    accessRetrying: "檢查中…",
    accessSignIn: "在新分頁重新登入（保留這頁輸入）",
    accessPrivacyNotice: "登入及使用檢查會傳送帳戶識別，服務會接收 IP 及時間；不傳課堂資料。",
    accessChecking: "正在檢查 Free Trial 使用權限…",
    accessConfirmed: "已確認 Free Trial 使用權限。",
    accessExpired: "Free Trial 使用權限已到期。",
    accessRevoked: "Free Trial 使用權限已被撤銷。",
    accessDenied: "伺服器未授予 Free Trial 使用權限；請重新檢查或聯絡支援。",
    accessUpdateRequired: "另一部裝置已使用較新版本的課序。請更新此裝置，之後才可保存或同步。",
    signin: {
      title: "登入你的帳戶",
      description: "首次使用亦可透過 Google 建立免費試用帳戶。",
    },
    previewNotice: "<preview>預覽模式</preview> 登入服務尚未接駁 Supabase；你仍可查看完整介面。",
    google: "使用 Google 繼續",
    googleBusy: "正在前往 Google…",
    installPrompt: "想下次更快開啟？",
    localPreview: "只限本機預覽：略過登入 →",
    legal:
      "繼續即表示你同意<terms>服務條款</terms>，並已閱讀<privacy>私隱政策</privacy>。使用真實學生資料前，請確認符合學校規定及適用的資料保障要求。",
    errors: {
      unavailable: "登入暫時未能完成，請稍後再試。",
      rateLimit: "嘗試次數太多，請稍後再試。",
      unconfigured: "登入服務尚未接駁；請先完成 Supabase 設定。",
    },
  },
  screenSupport: {
    brandSymbol: "課",
    brandEnglish: "Class in Order",
    brandName: "課序",
    eyebrow: "DESKTOP FIRST",
    title: "手機版暫不支援",
    description: "Demo 及 Free Trial 請改用電腦或 iPad 開啟，建議使用至少 768px 寬的螢幕。",
    continuationTitle: "稍後在電腦或 iPad 繼續",
    continuationDescription: "先複製網址，傳給自己或存起來，再用電腦或 iPad 的瀏覽器開啟。",
    copyLink: "複製試用網址",
    copying: "正在複製…",
    copied: "網址已複製，可貼到你自己的訊息或備忘錄。",
    copyManually: "瀏覽器未能自動複製，請長按下方網址並複製。",
    entryLink: "試用入口網址",
    continuationDataNote: "網址只供開啟入口，不會轉移本機課堂資料。",
    detail: "此提示按螢幕及視窗寬度判斷。支援的電腦或 iPad 放大瀏覽器、縮窄視窗後仍可繼續操作，未保存輸入亦會保留。",
    legalLabel: "政策文件",
    privacy: "私隱政策及收集個人資料聲明",
    terms: "服務條款",
    dataProcessing: "學校資料處理條款",
  },
  legalPolicy: {
    skip: "跳到法律內容",
    navigation: "法律文件",
    privacyLink: "私隱政策",
    termsLink: "服務條款",
    dataProcessingLink: "資料處理條款",
    version: "版本 {{version}} · Demo／Free Trial 本機版",
    missing: "待填（正式公開前補齊）",
    operator: "營運者：",
    contactName: "資料保障聯絡人：",
    contactEmail: "電郵：",
    supportLink: "支援及帳戶刪除",
    setupTitle: "聯絡設定未完成",
    setupDescription: "請設定營運名稱、資料保障聯絡職銜、聯絡電郵及主要資料庫地區。",
    privacy: {
      title: "私隱政策及收集個人資料聲明",
      summaryTitle: "目前的資料界線",
      summary:
        "本服務面向台灣、香港及澳門的教師與學校。Demo 使用虛構資料；Free Trial 供真實課堂試用，可在符合學校規定及適用法律的前提下使用真實學生資料。課堂資料保存在目前瀏覽器；Google 登入、帳戶使用權限檢查及你確認提交的自願回饋需要連線。本機小測、AI 出題及收費版尚未開放。",
      operatorTitle: "1. 營運者及聯絡方法",
      operator:
        "本服務營運者負責其處理的教師帳戶、使用權限、自願回饋及必要的服務保安資料。學校或教師在本機管理課堂資料，營運者不會自動讀取或保管學生記錄。資料保障及權利要求可向以下聯絡人提出；實際法律角色及責任仍按各方的用途、控制和處理行為及適用法律判斷。",
      accountTitle: "2. 教師 Google 登入收集個人資料聲明",
      account:
        "Free Trial 目前只提供 Google 登入，首次登入亦透過 Google 建立帳戶，沒有電郵註冊入口。Google 及 Supabase Auth 處理帳戶識別碼、電郵，以及 Google 帳戶提供的姓名或頭像資料，用於建立及識別教師帳戶、驗證登入、檢查使用權限、保障帳戶及提供支援。資料由登入流程傳送及以電子方式處理；平台不會取得你的 Google 密碼，亦沒有要求讀取 Gmail 或 Google Drive 內容的額外權限。使用 Free Trial 須提供所需帳戶資料；不提供便不能登入，但仍可使用免登入 Demo。",
      localTitle: "3. 真實課堂資料及 Demo",
      syncTitle: "自願啟用 Google Drive 同步",
      sync: "Free Trial 用戶自願啟用並授權 Google Drive 後，課序會把同步範圍內的班別、學生、課堂、功課、出勤、座位及工具設定，在裝置上加密後傳送到你確認的 Drive 應用程式資料空間。此授權不讀取一般 Drive 檔案或 Gmail。同步控制服務處理帳戶、裝置公開識別、配對密文及加密保存的 Google 授權資料，不接收學生資料明文或可解密課堂資料的秘密。裝置本機資料仍須自行保護。",
      syncLimitedUse:
        "課序使用透過 Google API 取得的資料，會遵守 Google API Services User Data Policy（包括 Limited Use 要求）。這些資料只用於你選擇的登入及同步服務，不用於廣告或訓練 AI 模型。",
      syncRetention:
        "同步須由你主動啟用，其他裝置首次掃 QR 配對；不要求生物辨識或自行保存同步金鑰。請保留至少一部已配對裝置及其網站資料，全部遺失後不能只靠 Google 登入解密雲端資料。撤回 Google 授權會停止後續同步，並不自動刪除本機或 Drive 中既有資料。同步不能取代獨立備份。",
      local:
        "你為教學管理輸入或匯入的班別、學生姓名、班號及可選性別、座位、分工、日曆、出席、功課、分數及課堂記錄，保存在目前裝置的瀏覽器。未另行啟用同步時，不會因登入、保存或檢查使用權限而把這些課堂資料上載到 Supabase、Google、Cloudflare 或 AI 服務。名單匯入、報表匯出、備份及還原在裝置完成；跨裝置同步須另行啟用。學校或教師須就實際收集用途、必要資料、告知、適用的授權或同意及保存期限作出安排；本聲明不代替學校向學生或家長提供的資料收集告知。",
      demo: "Demo 的改動只留在今次瀏覽的記憶體，重新載入或重設便會還原虛構示例；Demo 不讀寫 Free Trial 的本機資料，也不需要教師帳戶使用權限檢查。",
      feedbackTitle: "4. 自願回饋收集個人資料聲明",
      feedback:
        "回饋完全自願，供處理問題、改善試用體驗及按你選擇以電郵跟進。你亦可透過支援電郵提供安全的問題描述、提出個人資料要求或聯絡跟進；支援電郵由 Gmail／Google 處理。一般支援電郵由收到起最多保存 12 個月；權利要求及刪除的最少執行紀錄一般完成後最多保存 12 個月，必要法律保留會記錄依據及檢視期限。試用回饋先預覽，再確認提交；成功提交時，Supabase 會保存你填寫的類別、內容、可選跟進電郵，以及已驗證帳戶識別碼和接收時間，供獲授權的營運及支援人員處理。回饋並非匿名，不自動附學生、班級、資料庫、操作紀錄、截圖或備份。請勿在回饋填寫學生姓名、可識別學生的描述或其他人的個人資料。不提交回饋不影響試用；不提供跟進電郵亦不影響試用，但我們不能按該電郵跟進。",
      networkTitle: "5. 連線、接收者及跨境資料處理",
      network:
        "Free Trial 在啟動、回到前景及使用期間定期檢查帳戶使用權限。請求只傳帳戶驗證所需資料，不附課堂資料；基礎設施仍會接收連線 IP 及時間，以及正常連線所需的瀏覽器和請求資料，用於提供網站、故障排查及保安。我們只讓有工作需要的營運或支援人員及下列服務供應商處理相關資料；如依法須向主管機關提供資料，會限於適用法律要求的範圍。",
      providerName: "供應商",
      providerUse: "目前用途",
      googleName: "Google",
      supabaseName: "Supabase",
      cloudflareName: "Cloudflare",
      google: "Google 登入、帳戶識別及你寄送的支援電郵",
      supabase: "教師帳戶驗證、Free Trial 使用權限及成功提交的自願回饋；不接收本機課堂記錄",
      cloudflare: "網站與程式資源傳送、網絡保安及必要技術記錄；不接收本機課堂記錄",
      region:
        "公開服務將使用獨立的正式 Supabase 專案，主要資料庫地區：{{region}}，用於教師帳戶及成功提交的回饋。台港澳用戶登入或提交回饋會涉及境外處理。Google 登入及供應商的網絡、支援、技術記錄或備份可能涉及其他地區，主要資料庫地區不代表所有資料只在新加坡處理。相關境外服務依其資料處理及私隱條款處理，學校採用前應評估適用要求。本機學生資料不會因此存入這個資料庫。",
      retentionTitle: "6. 保存期限、備份及刪除",
      retention:
        "本機課堂資料的保存期限由學校或教師按教學用途及適用法律管理，目的完成或不再需要時應適當刪除。清除網站資料、重裝或更換瀏覽器／裝置可能失去記錄；登入同一 Google 帳戶不會取回資料。請定期下載加密備份，另行保管密碼；忘記密碼無法還原。還原備份會取代目前帳戶在這個瀏覽器的資料，請先保留現有備份並核對提示。",
      externalBackup:
        "若你自行把加密備份放入 iCloud Drive、Proton Drive 或其他同步資料夾，檔案上傳及保存由你選用的同步程式和服務處理。本產品只把密文備份寫到你確認的目的地，不會自動啟用雲端同步。匯出的 Word、Excel、PDF 或 CSV 報表可能是可讀取的檔案，請妥善保管。",
      accountRetention:
        "教師帳戶資料在提供帳戶服務所需期間保存，包括試用結束後提供查閱、匯出及備份的期間；不會只因未付費或試用到期而刪除帳戶。收到刪除要求，或帳戶服務目的不再存在時，按適用法律刪除或停止相關處理。只有履行法律義務、處理尚未完成的爭議或保安事件等具體必要情況，才保留所需的最少資料，並定期檢視保留需要。",
      feedbackRetention:
        "自願回饋及跟進電郵一般由收到回饋起保存 12 個月，期限屆滿後於每日清理時刪除。若個別問題、投訴或保安事件仍須處理，僅保留完成該事項所需的資料，記錄延長原因並定期檢視，完成後刪除；不會因一般改善產品的目的而無限期保存。",
      providerRetention:
        "供應商技術記錄及備份的保存、輪替和清理按其實際服務設定處理，不會承諾刪除主資料後所有副本即時消失。你可透過資料保障聯絡電郵查詢與你的要求相關的供應商清理安排。依法需要保留的資料不會繼續用於原目的以外的日常用途；如須從備份復原，亦須重新處理已確認的刪除要求。",
      accessTitle: "7. 試用結束、唯讀及資料復原",
      access:
        "免費試用結束後，未付費用戶停止新增及修改，但保留查閱、匯出及下載加密備份，本機資料不會因此刪除。現有使用權限到期或撤銷亦轉為唯讀。網絡故障時，上次成功檢查起 10 分鐘內可繼續保存，其後唯讀；成功重新驗證並確認寫入權限後才恢復新增及修改。主動刪除帳戶會終止登入能力，提出要求前請先安排資料匯出及備份。",
      securityTitle: "8. 裝置及帳戶保安",
      security:
        "正式網站及帳戶服務須使用加密傳輸，下載的加密備份以密碼保護。瀏覽器中的資料庫本身不等同加密備份。請保護裝置、瀏覽器及 Google 帳戶，限制可接觸學生資料的人員，避免共用瀏覽器設定檔。Free Trial 按登入帳戶分隔本機工作區，切換帳戶後只顯示該帳戶的紀錄；舊版共用資料須由擁有者確認歸屬。這是應用程式內的存取分隔，不能阻止可直接操作瀏覽器檔案或開發工具的人存取裝置資料。登出不會清除已保存紀錄。營運者亦須維護其服務、存取控制及保安措施。",
      requestsTitle: "9. 個人資料權利、刪除要求及事故",
      requests:
        "你可依適用法律要求查閱、取得複本、補充或改正個人資料，以及停止處理、刪除或撤回以同意為基礎的處理。教師帳戶及已提交回饋的要求可向以上聯絡人提出；我們會以合理且必要的方式核實身分，並按適用法律的期限答覆及處理。不會要求你為此寄送學生名單、完整資料庫或備份密碼。如未能全部滿足要求，會說明適用理由及後續途徑；你亦可向所在地的資料保障主管機關提出查詢或投訴。",
      deletion:
        "請使用「支援及帳戶刪除」頁的聯絡方法，從登入帳戶的電郵提出要求；我們會核實身分及刪除範圍，並在執行後告知結果。刪除要求以收到要求起 30 日內完成為一般營運目標，身分核實會盡快進行；此目標不取代適用法律的答覆、准駁或處理期限，較短的法定期限仍須遵守。如有依法保留的必要或合法延長情況，會告知原因及安排。刪除平台帳戶不會刪除你的 Google 帳戶，也不能遠端清除裝置中的課堂資料、匯出報表或自行保存的備份。學生或家長就本機學生記錄提出要求時，應聯絡掌握資料的教師或學校；營運者可提供操作支援。",
      incidents:
        "如懷疑帳戶或資料外洩，請提供事件時間和不包含學生個人資料的問題描述。營運者會就其處理的資料及服務查明、控制和跟進事故，並按適用法律履行通知或通報責任；學校或教師亦須就其掌握的課堂資料及裝置事故作出處理。",
      reference: "本聲明參考以下告知指引及法例：",
      referenceLink: "擬備收集個人資料聲明及私隱政策聲明指引",
      taiwanReference: "台灣《個人資料保護法》",
      macauReference: "澳門《個人資料保護法》",
    },
    terms: {
      title: "服務條款",
      scopeTitle: "1. 目前服務及使用資格",
      scope:
        "本條款適用於你使用由{{operator}}營運的「課序」Demo／Free Trial 本機版，服務面向台灣、香港及澳門的教師與學校。Demo 提供虛構示例；Free Trial 供真實課堂試用，可使用真實學生資料，前提是用途合法、資料限於教學管理所需，並符合學校規定及適用的資料保障要求。",
      adoption:
        "老師可自行開立帳戶，學校亦可統一安排採用；目前每位老師仍須使用各自的 Google 帳戶及本機資料。學校集中管理、共同帳戶及多人共用同一套雲端課堂資料尚未提供。老師自行建立帳戶，不表示其代表學校訂約或已取得校內所需批准；如代表學校作出安排，須有相應權限。",
      supportTitle: "2. 裝置及可用功能",
      support:
        "目前以支援所需本機儲存能力、螢幕至少 768px 寬的電腦瀏覽器使用為主。支援裝置放大瀏覽器或縮窄視窗後仍可使用課堂工具；窄屏手機顯示接續提示，政策文件仍可閱讀。Free Trial 暫時只支援 1 部裝置，資料保存在使用中的瀏覽器。本機小測、AI 出題、自動跨裝置同步及收費版尚未開放。",
      freeTitle: "3. 免費試用及後續收費安排",
      free: "Free Trial 目前免費、毋須信用卡，不會自動扣款；免費試用不代表服務永久免費。營運者計劃於合適時機推出收費版，屆時會先公布價格、試用結束日期、可用功能、裝置及資料安排，以及適用的付款、取消和退款條款，讓你決定是否付費。價格及具體推出日期仍待確認；版本更新或繼續查閱資料不會自動構成付費訂閱。",
      unpaid:
        "免費試用結束後，未付費用戶停止新增及修改資料，但保留查閱、匯出及下載加密備份，不會只因未付費而刪除帳戶或本機課堂資料。這些功能仍須在保留原資料的瀏覽器及服務可用範圍內使用，不能用同一帳戶在其他裝置自動取回記錄。若日後擬停止相關服務，須另行公告資料取回安排，並遵守適用法律及不能排除的使用者權利。",
      dataTitle: "4. 本機資料及備份責任",
      data: "你或學校對輸入及匯入資料的既有權利不因使用服務而轉移；學生及其他資料當事人的法定權利亦不受影響。學校或教師須管理資料內容、必要存取權、保存期限、裝置保安、備份及匯出檔案。Free Trial 把課堂資料保存在目前瀏覽器，營運者沒有課堂資料的伺服器副本。清除網站資料、更換裝置或瀏覽器後，登入帳戶不會自動恢復資料，須用自行保管的加密備份還原。",
      restore:
        "從備份或舊版檔案還原／匯入會取代目前瀏覽器的資料，不會自動合併。請先備份、核對來源及畫面提示，再確認操作。請分開保管備份密碼；營運者不能替你找回忘記的密碼。",
      conductTitle: "5. 使用者責任",
      conduct:
        "使用真實學生資料前，須確認學校政策、合法教學用途及適用的授權、告知或同意安排；同意並非每種情況唯一的法律依據。只輸入必要且適當的資料，維持準確性，並按需要更正或刪除。避免記錄與教學管理無關的身分證號碼、醫療或其他敏感資料；如確須處理受特別規範的資料，須先確認符合相應法律要求。請勿把學生個人資料、Google 密碼或備份密碼放入回饋或支援訊息。不得冒用他人帳戶、干擾服務或繞過存取限制。",
      connectionTitle: "6. 連線、唯讀及帳戶停止使用",
      connection:
        "Free Trial 首次確認使用權限及啟動／回到前景檢查需要網絡。網絡故障的 10 分鐘寬限由上次成功檢查起計，失敗不延長；使用權限到期或撤銷立即唯讀。唯讀仍可查閱、匯出及下載加密備份，本機資料不會因此刪除。帳戶刪除要求按私隱政策處理；主動刪除帳戶會終止登入能力，但不會替你清除裝置上的課堂資料，請先安排匯出及備份。",
      changesTitle: "7. 版本更新、服務責任及爭議處理",
      changes:
        "Free Trial 的功能及相容性仍在改善，營運者會以合理措施維護服務、修正問題及保障其處理的資料，並在平台公布影響使用或資料處理的重要變更；如變更依法需要重新取得同意，會另行處理。遇到問題可透過自願回饋或下列聯絡方法提出。試用不保證符合每間學校的全部行政需要，學校仍須按其職責保管正式紀錄；各方須承擔依法不能排除的責任，本條款不構成全面免責。",
      law: "本條款受香港法律管轄。發生爭議時，先透過書面聯絡尋求解決；未能解決的爭議交由香港法院處理。任何法律或法院安排均不限制台灣、香港或澳門適用法律下不能排除的資料保障、消費者或其他權利。學校另有與營運者簽署的採購合約時，依該合約約定處理文件之間的優先順序，並保留適用法律的強制規定。",
      contactTitle: "8. 聯絡",
    },
    processing: {
      title: "學校資料處理條款",
      scopeTitle: "1. 本機版的適用範圍",
      scope:
        "本文件適用於台灣、香港及澳門的教師自行採用或學校統一安排使用「課序」Demo／Free Trial 本機版，補充服務條款及私隱政策。Free Trial 可用於真實課堂及處理真實學生資料；學校安排採用時，目前仍由每位老師以獨立 Google 帳戶使用各自的本機資料，沒有學校集中管理或多人共用雲端資料的功能。Demo 只提供虛構示例。",
      responsibilitiesTitle: "2. 課堂資料、各方角色及責任",
      responsibilities:
        "班別、學生姓名、班號及可選性別、課堂記錄、功課、分數、出席、座位、分工、日曆及匯入檔案在老師的裝置中處理。學校或教師須按實際職責確定合法教學目的、必要資料、告知、適用的授權或同意、保存期限及可存取人員；老師須在校內授權及政策範圍內操作，並處理資料準確性和當事人權利要求。學生或家長的同意是否必要，須按具體用途及適用法律判斷，不能一概以接受本服務條款代替。",
      providerResponsibilities:
        "營運者提供本機處理軟件及相關帳戶服務，不會自動讀取或保管學生記錄，也沒有可供取回的課堂資料伺服器副本；本安排沒有委託營運者在雲端保存、評分或備份學生資料。營運者仍須維護軟件及其處理的帳戶、回饋和服務保安資料，履行適用的保安及資料保障責任。各方的法律角色按實際決定目的、控制及處理行為判斷，不單憑「本機」或本文件的稱呼免除法定責任。",
      onlineTitle: "3. 帳戶、使用權限及自願回饋",
      online:
        "Google 和 Supabase 處理教師帳戶識別及使用權限；成功確認提交的自願回饋由 Supabase 保存。公開服務將使用獨立正式專案，主要資料庫在新加坡；Google 登入及供應商的其他服務可能涉及其他地區。Cloudflare 提供網站及必要網絡保安。這些網絡服務不等同收到本機學生資料；相關資料類別、用途、接收者、保存期限及權利要求方式見私隱政策。學校須依其適用規定評估帳戶及回饋的境外處理安排。",
      backupTitle: "4. 匯出、備份及自行選用的同步服務",
      backup:
        "匯出及加密備份在裝置完成。學校或教師須限制裝置和瀏覽器設定檔的存取權，保管檔案及密碼，按校內規定備份及刪除，並核對還原會取代目前資料的提示。匯出報表可能可直接讀取；加密備份不代表瀏覽器資料庫本身已加密。自行使用同步資料夾或雲端儲存服務時，須評估其存取權、資料地區及保存安排；本服務不會因此自動啟用跨裝置同步。",
      assistanceTitle: "5. 查閱、改正、刪除及事故支援",
      assistance:
        "學生或家長就本機課堂資料提出查閱、改正或刪除等要求時，須由掌握資料的學校或教師按適用法律處理；營運者可提供操作支援，但不能遠端讀取、恢復或刪除本機記錄。教師帳戶及已提交回饋的要求向營運者提出，按私隱政策及適用法定期限處理。發生事故時，各方須就其控制的資料及服務採取適當措施，並依法通知或通報；支援訊息只應提供不含學生個人資料的問題描述，不傳送完整資料庫或備份密碼。",
      endingTitle: "6. 唯讀、停止使用及資料交接",
      ending:
        "免費試用結束後，未付費用戶停止新增及修改，但保留查閱、匯出及下載加密備份，不會只因未付費而刪除帳戶或本機課堂資料。使用權限到期、撤銷或網絡寬限結束亦轉為唯讀。老師離職、轉校或停止使用時，學校及老師須按校內規定及適用法律安排資料交接、取回和刪除，不代表離職老師可永久保留學生記錄。帳戶登出或刪除不等同清除本機資料；主動刪除帳戶前請先匯出及備份。",
      futureTitle: "7. 日後收費及新增資料處理",
      future:
        "轉為收費服務不會自動授權上載既有本機學生資料。如日後提供學校集中管理、多人共享、雲端儲存、自動同步、學生小測或 AI 功能，須先另行說明資料處理範圍、法律角色、供應商、地區、保安、保存及刪除安排，並按適用情況訂立所需約定及取得授權或同意。現有本機試用條款不預先授權這些新增處理。",
      contactTitle: "8. 聯絡",
    },
  },
  support: {
    skip: "跳到支援內容",
    navigation: "支援頁導覽",
    privacy: "私隱政策",
    terms: "服務條款",
    app: "返回 Free Trial",
    title: "支援及帳戶刪除",
    intro: "課序由 {{operator}} 提供支援。一般使用問題、個人資料要求及保安事故，均可透過以下電郵聯絡資料保障聯絡主任。",
    helpTitle: "使用問題與跟進",
    help: "已登入的老師可使用「提供試用回饋」先預覽再提交；無法登入或需要電郵回覆時，請直接寫信。",
    safeDetails:
      "請提供發生時間、裝置及瀏覽器版本、操作步驟，以及已去除個人資料的錯誤文字。請勿傳送學生名單、課堂資料庫、完整備份、Google 密碼或備份密碼；截圖請先遮蓋學生及其他人的資料。",
    response:
      "一般查詢以 3 個香港工作天內確認收到及分類為目標；修復時間視問題而定，需要更多時間時會說明跟進安排。這是服務目標，並非即時或全天候支援。",
    helpSubject: "課序｜使用支援",
    helpAction: "以電郵提出使用問題",
    deleteTitle: "申請刪除平台帳戶",
    deleteBefore:
      "刪除後不能再用原帳戶登入課序。請先在「資料與備份」匯出所需紀錄及下載加密備份，核對檔案可用並妥善保管。",
    deleteRequest: "從你的登入電郵寄信，主旨為「課序｜刪除帳戶」，寫明要求刪除課序帳戶及已提交的回饋。毋須附學生資料。",
    deleteVerify: "我們會透過原帳戶電郵核實要求、確認已安排資料匯出及需刪除的範圍；未完成核實前不執行刪除。",
    deleteComplete:
      "獲確認後，移除平台登入帳戶及其關聯回饋，核對刪除結果，再以電郵告知完成或依法保留的最少資料及原因。",
    deleteScope: "刪除的是課序帳戶，並不刪除你的 Google 帳戶。若日後重新透過 Google 登入，可能會建立新的課序帳戶。",
    deleteLocal:
      "平台無法遠端清除你裝置上的課堂資料、匯出報表或備份。停止使用後，請按學校規定處理交接及本機刪除；登出或切換 Google 帳戶亦不會清除本機資料。",
    deadline:
      "刪除以收到要求起 30 日內完成為一般營運目標；適用法律要求較短期限時以該期限為準。身分核實不會任意重設起算日；若依法需要保留或延長，會說明原因及安排。",
    deleteSubject: "課序｜刪除帳戶",
    deleteAction: "以電郵申請刪除帳戶",
    emailNotice: "此連結只開啟你的郵件程式；請自行確認內容並寄出，點擊不會提交申請或立即刪除帳戶。",
    rightsTitle: "查閱、更正及其他個人資料要求",
    rights:
      "請寫明要求範圍及所屬地區，我們會按適用期限處理。學生或家長對本機學生紀錄的要求，應向掌握資料的教師或學校提出；我們可提供操作支援。毋須預設提交身分證副本。",
    rightsSubject: "課序｜個人資料要求",
    rightsAction: "聯絡資料保障聯絡主任",
    feedbackTitle: "回饋的保存及刪除",
    feedback:
      "試用回饋不是匿名：只保存你確認提交的類別、內容、可選跟進電郵、帳戶識別碼及接收時間，不會自動附帶學生資料或截圖。",
    feedbackRetention:
      "一般從收到起保存 12 個月，到期後於每日清理時刪除。未完投訴、保安事件或法律義務，只保留處理該事項必要的資料，記錄原因及下次檢視日期，完成後刪除。你亦可提出較早刪除要求。",
    securityTitle: "帳戶或資料保安事故",
    security:
      "請在主旨註明「保安事故」，提供時間、受影響的資料類別及安全的問題描述。營運者會優先評估、控制及跟進自身服務事故；裝置及本機學生資料事故亦應立即通知學校負責人。",
    securitySubject: "課序｜保安事故",
    securityAction: "回報保安事故",
  },
  pwaInstall: {
    checkUpdate: "檢查更新",
    updatePending: "更新待處理",
    updateStatus: "課序更新",
    closeStatus: "收起",
    versionLabel: "版本 {{build}}",
    currentVersion: "目前版本：{{build}}",
    versionChanged: "網站已有較新版本，請重新檢查並等候下載完成。",
    websiteSignIn: "重新登入網站",
    accessRestored: "已連接課序網站",
    returnToUpdate: "返回原本的課序分頁後會自動檢查更新，未保存的工作仍在原分頁。",
    returnToWorkspace: "返回原本分頁",
    status: {
      idle: "按「檢查更新」核對網站版本。",
      checking: "正在檢查網站版本…",
      current: "已是最新版。",
      downloading: "發現新版本，正在下載。你可以繼續工作。",
      ready: "新版已下載，保存工作後即可更新。",
      "auth-required": "網站需要重新登入，暫時未能檢查或下載新版。登入後返回此頁會自動再檢查。",
      offline: "目前未連線，暫時未能檢查更新。已保存的本機資料會保留。",
      failed: "未能完成更新檢查或下載。請保持連線並再試；目前版本及本機資料會保留。",
    },
    updateTitle: "Free Trial 有新版本",
    installed: "✓ 已加到主畫面",
    install: "加到主畫面，方便下次使用",
    iosHelp: "iPhone／iPad：按 Safari「分享」→「加至主畫面」。",
    browserHelp: "可在瀏覽器選單選擇「安裝應用程式／加至主畫面」。",
  },
  guidedTour: {
    regions: {
      demo: "Demo 功能導覽",
      setup: "Free Trial 互動新手教學",
    },
    mascot: "課",
    progress: {
      demo: "Demo 功能導覽 · {{chapter}}／{{total}}",
      setup: "工具精靈 · 任務 {{chapter}}／{{total}}",
    },
    preparing: "畫面正在準備指示位置。你可以先略過，稍後再開啟互動教學。",
    actions: {
      close: "關閉導覽",
      skip: "略過教學",
      manualSetup: "自行設定",
      editRoster: "← 返回修改名單",
      back: "← 上一項",
    },
    steps: {
      className: {
        title: "先替課堂起個名字",
        message: "在亮起的欄位輸入測試班別，例如「1A 中文」。填好後按「下一步」。",
        next: "下一步 →",
      },
      classRole: {
        title: "選擇班別用途",
        message: "任教班別用來記錄課堂；班主任班可用點名等班務工具。選好適合的用途後繼續。",
        next: "下一步 →",
      },
      classSubmit: {
        title: "建立你的第一班",
        message: "按亮起的「新增班別」。成功建立後，我會帶你去匯入名單。",
      },
      rosterLink: {
        title: "下一站：學生名單",
        message: "按「匯入名單」，我會帶你到這個班別的匯入欄。",
      },
      rosterInput: {
        title: "貼上學生名單",
        message: "從 Excel 複製學生名單貼上，欄名可省略。匯入後保存在目前瀏覽器。",
        next: "已填好，下一步 →",
      },
      rosterSubmit: {
        title: "檢查並匯入",
        message: "按「檢查並匯入」。若名單有資料問題，可返回修改後再試；匯入成功才會進入座位表。",
      },
      seatingLink: {
        title: "編排座位表",
        message: "按「編排座位」，前往這個班別的座位表。",
      },
      seatingNav: {
        title: "打開座位表",
        message: "在左邊工具欄按「座位表」。如果工具欄已收起，可用下方按鈕直接前往。",
        next: "帶我去座位表 →",
      },
      seatingStudent: {
        title: "先選一位學生",
        message: "按亮起的學生姓名。也可以拖曳，但第一次跟着按會更容易。",
      },
      seatingSeat: {
        title: "再按一個空位",
        message: "選好學生後，按亮起的空位；學生便會放到座位表上。",
      },
      seatingSave: {
        title: "正在保存座位表",
        message: "座位安排會自動保存。保存成功後，可繼續替其他學生安排位置。",
      },
      demoWelcome: {
        title: "快速認識每項功能",
        message: "Demo 已備好虛構班別、名單和記錄。每頁簡介一項功能，可隨時返回或關閉導覽。",
        next: "開始功能導覽 →",
      },
      demoToday: {
        title: "日曆首頁",
        message: "集中查看各班與全校事項，掌握未來兩星期及全年安排。點擊左上角「課序」標誌即可返回首頁。",
        next: "下一項功能 →",
      },
      demoPerformance: {
        title: "課堂表現",
        message: "表現總覽按學生查看回應、欠帶書簿及備註，也可篩選要留意的記錄。點「比較學期表現」查看各學期變化。",
        next: "下一項功能 →",
      },
      demoCoursework: {
        title: "課業與成績",
        message: "課業概覽提醒需要跟進的事項；成績總表供整班查閱，分數及繳交狀態在事項記錄處理。",
        next: "下一項功能 →",
      },
      demoGroups: {
        title: "抽人分組",
        message: "沿用班中名單隨機抽學生，或按指定組數快速分組，方便課堂問答與小組活動。",
        next: "下一項功能 →",
      },
      demoSeating: {
        title: "座位表",
        message: "編排學生座位、切換教師與學生視角。點名及課堂記錄沿用同一座位表。",
        next: "下一項功能 →",
      },
      demoCalendar: {
        title: "日曆",
        message:
          "查看校曆及班別安排，按「＋新增事項」加入功課、測驗、默書或提醒。課業日期會連動「課業與成績」的學生記錄。",
        next: "下一項功能 →",
      },
      demoAttendance: {
        title: "班主任點名",
        message: "按座位切換出席或缺席，每次點選自動保存每日出勤記錄。",
        next: "下一項功能 →",
      },
      demoHomeroomHomework: {
        title: "欠交記錄",
        message: "按科目與課業集中記下欠交學生，方便班主任追蹤補交情況。",
        next: "下一項功能 →",
      },
      demoStudentRecords: {
        title: "學生個人記錄",
        message: "集中查閱每位學生的點名、欠交與日常跟進記錄，需要時可匯出。",
        next: "下一項功能 →",
      },
      demoHomeroom: {
        title: "班務事項",
        message: "日常備忘保留學生的持續安排；班務記事記下班會、通告及需要跟進的事情。",
        next: "下一項功能 →",
      },
      demoHomeroomDuties: {
        title: "學生職務",
        message: "沿用學生名單安排班長、科長和值日等職務，集中管理學生職務。",
        next: "下一項功能 →",
      },
      demoToolSettings: {
        title: "工具管理",
        message: "在後台管理的「工具管理」分頁，選擇側欄顯示的工具；隱藏工具時，相關資料仍會保留。",
        next: "下一項功能 →",
      },
      demoRoster: {
        title: "後台管理",
        message: "集中建立班別、匯入學生名單、管理校曆及補回歷史記錄。",
        next: "下一項功能 →",
      },
      demoData: {
        title: "訂閱與資料",
        message: "Demo 改動只留在今次瀏覽，重新載入便會還原。Free Trial 可在同一裝置保存自己的課堂資料。",
        next: "完成導覽 →",
      },
    },
  },
  homeroomNotebook: {
    title: "班務記事簿",
    addTitle: "記錄班務",
    date: "日期",
    event: "事項",
    note: "備註",
    add: "加入班務事項",
    edit: "編輯",
    editLabel: "編輯記事：{{title}}",
    editTitle: "編輯班務記事",
    save: "保存修改",
    saving: "正在保存…",
    cancel: "取消",
    delete: "刪除記事",
    deleteTitle: "刪除這筆記事？",
    deleteMessage: "「{{title}}」將會刪除，其他記事會保留。",
    confirmDelete: "確認刪除",
    back: "返回編輯",
    failed: "未能保存，輸入仍保留，請重試。",
    stale: "這筆記事已在其他地方更新。請取消後重新開啟，核對最新內容。",
    discard: "尚有未保存內容，確定關閉？",
    empty: "尚未有班務記事。",
    added: "記事已新增",
    updated: "記事已更新",
    deleted: "記事已刪除",
    search: "搜尋班務記事",
    placeholder: "例如：家長日安排、班會跟進",
  },
  assignmentRecords: {
    batch: {
      open: "批次輸入",
      title: "批次輸入",
      statusTab: "整班狀態",
      scoresTab: "貼上分數",
      scope: "套用對象",
      unrecorded: "未記錄學生（{{count}} 人）",
      everyone: "全班（{{count}} 人）",
      status: "設為",
      applyStatus: "套用至 {{count}} 人",
      replaceStatus: "會更新所選學生的狀態，保留現有分數。",
      format: "貼上格式",
      order: "依名單次序：一欄分數",
      number: "班號及分數：兩欄",
      text: "從 Excel 貼上資料",
      orderHint: "依目前名單次序，每人一行；空白分數會略過。",
      numberHint: "第一欄班號，第二欄分數；跨班名單請用完整班號，例如 4A（12）。空白分數會略過。",
      preview: "核對分數",
      student: "學生",
      previous: "原有分數",
      next: "新分數",
      skipped: "略過",
      applyScores: "套用 {{count}} 筆分數",
      replaceScores: "更新 {{count}} 筆分數，其中 {{existing}} 筆已有分數。",
      errorLine: "第 {{line}} 行：{{error}}",
      errors: {
        rowCount: "行數須與全班人數相同，請保留空白學生的行。",
        columns: "欄數不符合所選格式，請貼上 Excel 資料格。",
        student: "班號無法唯一對應學生，請核對完整班號。",
        duplicate: "同一學生重複出現。",
        score: "分數須為有效非負數，並且不可超過滿分。",
      },
      cancel: "取消",
      close: "關閉批次輸入",
      discard: "尚未套用批次輸入，確定關閉？",
      view: "登分顯示方式",
      table: "表格",
      cards: "卡片",
      tableHint: "Enter 下一人 · Shift + Enter 上一人",
      tableLabel: "整班登分表",
      statusApplied: "已套用 {{count}} 人的狀態",
      scoresApplied: "已套用 {{count}} 筆分數",
    },
    copy: {
      open: "複製到其他班",
      title: "複製課業到其他班",
      description: "只沿用事項內容、滿分與備註，各班重新記錄繳交狀態及分數。",
      class: "任教班別",
      date: "日期",
      folder: "資料夾",
      select: "選擇 {{name}}",
      dateLabel: "{{name}}：日期",
      folderLabel: "{{name}}：資料夾",
      empty: "目前沒有同學年可選的其他任教班別。",
      apply: "複製到 {{count}} 班",
      saving: "正在複製…",
      cancel: "取消",
      failed: "未能完成複製，請核對班別、日期及資料夾後重試。",
      stale: "原事項已更新，請關閉後重新開啟複製，核對最新內容。",
      success: "已複製到 {{count}} 班",
      discard: "尚有未完成的複製設定，確定關閉？",
    },
    studentRecords: "課業學生記錄",
    invalidScore: "分數須為 0 或以上，並且不可超過滿分；可留空。",
    scoreRejected: "分數須為 0 或以上；已保留原值。",
    scoreRangeRejected: "分數須介乎 0 至 {{maxScore}}；已保留原值。",
    enterRecords: "登分／繳交",
    enterExamRecords: "登分／應考",
    enterExamRecordsLabel: "登分／應考：{{title}}",
    actions: "操作",
    enterRecordsLabel: "登分／繳交：{{title}}",
    moreActions: "更多事項操作：{{title}}",
    editMetadata: "編輯事項資料",
    createTitle: "新增事項記錄",
    createAndRecord: "建立並登分",
    saveMetadata: "保存事項資料",
    cancel: "取消",
    close: "關閉事項表單",
    discardConfirm: "尚有未保存的事項資料，確定取消修改？",
    saveRecords: "保存學生記錄",
    delete: "刪除事項及登分",
    deleteTitle: "確認刪除事項及登分",
    deleteMessage: "刪除「{{title}}」及 {{count}} 位學生的已保存記錄？",
    deleteMessage_one: "刪除「{{title}}」及 {{count}} 位學生的已保存記錄？",
    deleteMessage_other: "刪除「{{title}}」及 {{count}} 位學生的已保存記錄？",
    deleteWarning:
      "相關日曆事項亦會一併移除（共用的日曆事項會保留）。這項操作無法復原；需要保留資料時，請先匯出或下載加密備份。",
    confirmDelete: "刪除事項及全部登分",
    deleteFailed: "未能刪除。事項及登分仍保留，請重試。",
    deleteUnavailable: "此版本未支援刪除事項，資料仍保留。",
    deleteChanged: "事項或學生記錄已更新，請重新檢視並確認刪除。",
    directoryTitle: "事項記錄目錄",
    folders: {
      create: "新增資料夾",
      manageTitle: "管理資料夾",
      manage: "管理「{{name}}」資料夾",
      open: "開啟{{name}}分類",
      name: "資料夾名稱",
      folder: "資料夾",
      recordType: "事項分類",
      count: "{{count}} 份記錄",
      count_one: "{{count}} 份記錄",
      count_other: "{{count}} 份記錄",
      uncategorized: "未分類",
      saveName: "保存名稱",
      delete: "刪除資料夾",
      deleteTitle: "確認刪除資料夾",
      deleteMessage: "刪除「{{name}}」資料夾？全部學期共 {{count}} 份記錄會移到「未分類」，學生狀態和成績會保留。",
      deleteMessage_one: "刪除「{{name}}」資料夾？全部學期共 {{count}} 份記錄會移到「未分類」，學生狀態和成績會保留。",
      deleteMessage_other:
        "刪除「{{name}}」資料夾？全部學期共 {{count}} 份記錄會移到「未分類」，學生狀態和成績會保留。",
      confirmDelete: "刪除並保留記錄",
      cancel: "取消",
      saving: "保存中…",
      failed: "未能保存。請使用不重複的資料夾名稱，或重新開啟後再試。",
      defaultNames: { homework: "功課", assessment: "測驗", dictation: "默書" },
      date: "事項日期",
      record: "學生記錄",
    },
    emptyCategory: "這個分類尚未有事項記錄。",
    schoolYear: "查閱學年",
    schoolYearLabel: "{{year}} 學年",
    viewTerm: "查閱學期",
    unassignedTerm: "未設定學期",
    assessmentDate: "測驗日期",
    dictationDate: "默書日期",
    homework: {
      statuses: { complete: "準時繳交", missing: "欠交", late: "已補交", excused: "豁免" },
      pendingMissing: "待補交",
      date: "繳交日期",
      record: "繳交記錄",
      state: "繳交狀態",
      studentState: "{{number}} 號 {{name}}：繳交狀態",
      missingList: "仍欠交 {{students}}",
      noMissing: "沒有已標記欠交的學生",
      saved: "學生記錄已保存；返回目錄即可查看欠交名單。",
    },
    exam: {
      statuses: { complete: "已應考", missing: "未應考", late: "已補考", excused: "豁免應考" },
      record: "應考記錄",
      state: "應考狀態",
      studentState: "{{number}} 號 {{name}}：應考狀態",
      missingList: "未應考 {{students}}",
      noMissing: "沒有已標記未應考的學生",
      saved: "學生應考記錄已保存。",
    },
  },
  recordSaveBar: {
    ready: "尚未輸入記錄",
    restored: "已還原未保存修改",
    group: "{{label}}操作",
    changed: "{{count}} 項未保存修改",
    saved: "已保存",
    saving: "保存中…",
    restore: "還原修改",
    restoreConfirm: "還原為上次保存的內容？這會取消畫面上尚未保存的修改。",
  },
  localData: {
    storageWarning: "清除網站資料可能失去記錄，請先下載備份。",
    persistenceRequest: "要求持久儲存",
    persistenceResult: "持久儲存要求結果",
    persistenceChecking: "檢查中",
    persistenceExplanation: "瀏覽器可能自行批准或不批准，未必會顯示詢問視窗。",
    persistencePending: "正在向瀏覽器要求持久儲存，請稍候…",
    persistenceGranted: "瀏覽器已允許持久儲存，仍請定期下載備份。",
    persistenceNotGranted: "瀏覽器暫未批准持久儲存。資料仍可儲存在本機；請定期下載備份，稍後可再試。",
    persistenceUnsupported: "這個瀏覽器未提供持久儲存要求功能。資料仍可儲存在本機；請定期下載備份。",
    persistenceError: "未能完成持久儲存要求，請稍後再試並定期下載備份。",
    passwordWarning: "忘記備份密碼便無法還原。",
    restoreWarning: "還原會取代全部本機課堂資料，請先下載現有備份。",
  },
  rosterPaste: {
    crossClass: "跨班選修科名單",
    sourceClass: "原班別",
    crossClassMissing: "跨班名單須有「班別、班號、姓名」欄，並填妥每位學生的班別。",

    importTitle: "匯入學生",
    format: "匯入格式",
    excelMethod: "Excel 檔案",
    csvMethod: "CSV",
    csv: {
      file: "學生名單 CSV（.csv，最多 10 MB）",
      content: "CSV 內容",
      placeholder: "班號,姓名,性別\n1,學生甲,M\n2,Taylor Chan,F",
      cancel: "取消 CSV 匯入",
      reading: "正在讀取 CSV…",
      errors: {
        fileType: "請選擇 .csv 檔案。",
        size: "CSV 檔案上限 10 MB，請先分拆名單。",
        read: "未能讀取 CSV，請另存為 UTF-8 CSV 後再試。",
        empty: "CSV 沒有學生資料。",
        cell: "未能讀取 CSV 內容。",
      },
    },
    excel: {
      title: "匯入 Excel 檔案",
      settings: "Excel 名單匯入設定",
      file: "學生名單 Excel（.xlsx，最多 10 MB）",
      reading: "正在讀取 Excel…",
      sheet: "工作表",
      genders: { M: "男", F: "女", X: "其他" },
      preview: "待匯入學生",
      summary: "{{className}} · 共 {{count}} 位學生（{{updates}} 位會更新現有相同班別及班號資料）",
      cancel: "取消 Excel 匯入",
      confirm: "確認匯入 {{count}} 位學生",
      saving: "正在匯入…",
      errors: {
        fileType: "請選擇 .xlsx 檔案；舊式 .xls 請先在 Excel 另存為 .xlsx。",
        columns: "未能辨識學生欄目。請使用「班號、姓名」欄名，性別欄可選填，再重新選檔。",
        class: "名單找不到與「{{className}}」相符的班別，請核對班別名稱或選用其他名單。",
        size: "檔案上限 10 MB；每張工作表最多 5,002 行、80 欄，全檔最多 50,000 個有內容儲存格。請先分拆名單。",
        empty: "Excel 沒有可讀取的資料。",
        read: "未能讀取 Excel。請確認檔案未損壞、未加密，並另存為 .xlsx 再試。",
        cell: "部分儲存格沒有可讀取的值。請在 Excel 重算公式，或將名單貼上為純值後再匯入。",
      },
    },
    input: "學生名單文字",
    placeholder: "1\t學生甲\tm\n2\tTaylor Chan\tf",
    title: "貼上 Excel 名單",
    submit: "檢查並匯入",
    errors: {
      empty: "名單沒有學生資料。",
      class: "檔案包含班別資料，請選擇要匯入的來源班別。",
      format: "第 {{line}} 行資料不完整。請核對班號（1–999）、姓名及各行的欄位數。",
      columns: "未能辨認名單，請只複製班號、姓名及選填性別的資料格，再貼上一次；欄位次序不限。",
      gender: "第 {{line}} 行性別未能辨認，請使用男／女／其他或 M／F／X（不分大小寫），也可留空。",
      duplicate: "班號 {{number}} 重複，請核對名單。",
    },
  },
  classroomInterface: {
    missingWorkAutosaveHint: "項目內容可留空；選擇科目及欠交學生後會自動保存，回條毋須選科目。",
    recordLocalOnly: "此記錄功能只在本機版及 Demo 提供。",
    demoLabel: "Demo · 虛構資料",
    resetDemo: "重設示範資料",
    demoSchoolYear: "Demo · 全年虛構資料 · {{year}} · 3 學期",
    localTrial: "Free Trial · 本機試用",
    continueSetupTitle: "完成課堂設定",
    setupTutorialComplete: "基本操作教學完成",
    rosterAndSeating: "學生名單及座位表",
    backupReminder: "尚未允許持久儲存，請定期備份。",
    backupReminderShort: "請定期備份",
    rosterFormat: "從 Excel 複製名單直接貼上，接受中英文姓名；欄名可省略，性別可留空。",
    autoSave: "自動儲存",
    noStudents: "尚未有學生名單。",
    noRoutineItems: "尚未建立日常事項。",
    chooseSubject: "請選擇科目。",
    sharedSeating: "共用座位表",
    noAnswers: "尚未收到答案。",
    demoDataNotice: "Demo 使用虛構資料，重新載入即會重設。",
    demoTrialAction: "想保存自己的課堂資料？進入 Free Trial →",
    homeTitle: "日曆首頁",
    switchClass: "切換班別",
    tools: "工具",
    openTools: "開啟工具欄",
    closeTools: "關閉工具欄",
    primaryTools: "主要功能",
    sidebarHidden: "收起側欄",
    sidebarExpand: "展開側欄",
    print: "列印",
    export: "匯出",
    exportIcs: "匯出 ICS",
    exportSeatingHint: "匯出目前班別的座位表 PDF",
    exportRecordsHint: "匯出目前班別的學生記錄",
    exportContextHint: "匯出目前班別及所選範圍的已保存記錄",
    required: "請填寫事項名稱和日期。",
    endBeforeStart: "結束日期不能早於開始日期。",
    saved: "「{{title}}」已加入日曆",
    saveFailed: "未能加入日曆，請再試一次。",
    entryTitle: "新增課堂事項",
    closeEntry: "關閉新增課堂事項",
    entryHelp: "加入「{{className}}」日曆，儲存後即時顯示。",
    itemType: "事項類型",
    other: "其他",
    itemName: "事項名稱",
    titlePlaceholder: "例如：完成工作紙三",
    date: "日期",
    note: "補充說明（選填）",
    notePlaceholder: "例如：範圍、頁數或需要帶備的物品",
    moreSettings: "更多日曆設定",
    schoolType: "校曆類型",
    endDate: "結束日期（可選）",
    cancel: "取消",
    saving: "加入中…",
    save: "加入日曆",
    help: "說明",
    back: "← 返回",
    replayDemo: "↻ 重看功能導覽",
    replayLocal: "↻ 從頭測試指引",
    classSelect: "選擇班別",
    classMenu: "班別選單",
    classTeaching: "任教班別",
    classHomeroom: "班主任班",
    studentCountLabel: "班別學生人數",
    dayCount: "查看 {{date}} 的 {{count}} 項事項",
    dayCount_one: "查看 {{date}} 的 {{count}} 項事項",
    dayCount_other: "查看 {{date}} 的 {{count}} 項事項",
    moreEvents: "＋{{count}} 項",
    countUnit: " 項",
    dayTitle: "{{date}} 的事項",
    holidayBadge: "放假",
    holidayDetail: "查看 {{date}} 的假期：{{title}}",
    eventCount: "{{count}} 項事項",
    eventCount_one: "{{count}} 項事項",
    eventCount_other: "{{count}} 項事項",
    shortEventCount: "{{count}} 項",
    shortEventCount_one: "{{count}} 項",
    shortEventCount_other: "{{count}} 項",
    holidayCount: "{{count}} 項假期",
    holidayCount_one: "{{count}} 項假期",
    holidayCount_other: "{{count}} 項假期",
  },
  localExport: {
    print: "列印",
    printTarget: "列印{{target}}",
    printPreview: "列印表格預覽",
    printFrom: "列印開始日期",
    printTo: "列印結束日期",
    printFailed: "未能列印，請再試一次。",
    printOpened: "已開啟列印。",
    printBoard: "黑板",
    printTeacher: "教師視角",
    printStudent: "學生視角",
    printEmptySeat: "空位",
    printNoSeating: "尚未儲存座位表",
    exportTarget: "匯出{{target}}",
    recordTypes: {
      records: "學生記錄",
      homework: "功課事項",
      attendance: "點名記錄",
      homeroomHomework: "欠交記錄",
      studentRecords: "學生記錄",
      homeroom: "班務事項",
      homeroomDuties: "學生職務",
      seating: "座位表",
      calendar: "日曆事項",
      quiz: "小測記錄",
      roster: "學生名單",
    },
    close: "關閉",
    allDates: "全部日期",
    privacy: "轉換及匯出在此裝置完成，不會上傳到轉換服務。",
    savedOnly: "匯出只包含已保存的記錄；修改後請先保存。",
    filteredScope: "沿用此頁的篩選結果；跨班或其他記錄可於後台「記錄匯出」處理。",
    rangeTitle: "日期範圍",
    dateSeparator: "至",
    from: "匯出開始日期",
    to: "匯出結束日期",
    rangeHint: "包含首尾兩天。日期留空時沿用目前學期；已選「全部日期」則匯出所有日期。",
    undated: "名單、目前分工及座位表不按日期篩選。",
    sheet: "預覽表格",
    preview: "匯出表格預覽",
    rowCount: "共 {{count}} 筆記錄",
    rowCount_one: "共 {{count}} 筆記錄",
    rowCount_other: "共 {{count}} 筆記錄",
    previewLimit: "預覽每頁顯示最多 10 筆；檔案及複製內容包含全部已篩選記錄。",
    csvHint:
      "CSV 及複製表格使用上方選中的表格；Excel、PDF、JSON 匯出整份報告。CSV 用 UTF-8，日期為 YYYY-MM-DD。若編號含開首的 0，匯入試算表時請把該欄設為文字，或使用 Excel 檔案。空白分數會保留空白。JSON 記錄匯出不適用於完整備份還原。",
    formats: { xlsx: "Excel", csv: "CSV", pdf: "PDF", json: "JSON" },
    pdfPreview: "PDF 頁面預覽",
    pdfPage: "第 {{page}} 頁，共 {{count}} 頁",
    pdfLoading: "正在載入 PDF 預覽…",
    pdfPreviewFailed: "未能載入 PDF 預覽，請重試。",
    downloadPdf: "下載 PDF",
    pdfDownloadStarted: "已開始下載 PDF。",
    retryPdf: "重新載入預覽",
    backToExport: "返回匯出選項",
    csv: "下載 CSV",
    copy: "複製表格",
    copied: "表格已複製。",
    downloaded: "已下載匯出檔案。",
    working: "正在產生內容…",
    failed: "未能匯出，請再試一次。",
    copyFailed: "未能存取剪貼簿，請改用下載 CSV。",
    errors: {
      invalidDate: "請填寫有效日期。",
      order: "結束日期不能早於開始日期。",
      outsideTerm: "匯出日期必須在目前學期內；需要其他日期時，請先選擇全部日期。",
    },
  },
  publicHolidays: {
    title: "香港公眾假期",
    coverage: "已自動標記 {{start}}–{{end}} 年",
    source: "官方來源：1823",
    unavailable: "尚未提供 {{years}} 年的官方假期資料。",
    importPurpose: "校曆匯入用於核對校內活動及學校假期。相符的公眾假期已標記，毋須重複匯入。",
    alreadyMarked: "官方公眾假期已標記，毋須重複匯入",
    officialDetail: "香港政府公布的公眾假期 · 自動標記",
  },
  calendarImport: {
    excelReview: "Excel 校曆來源與欄位對應",
    sheet: "工作表",
    missingMapping: "未辨認到日期與事項欄：自行指定欄位",
    changeMapping: "查看或修改欄位對應",
    headerRow: "標題列行號（0 表示沒有標題列）",
    startColumn: "開始日期欄",
    titleColumn: "事項名稱欄",
    endColumn: "結束日期欄（可選）",
    noteColumn: "備註欄（可選）",
    chooseColumn: "選擇欄位",
    none: "不指定",
    row: "行號",
    sourcePreview: "原始工作表預覽（首 5 行）",
    applyMapping: "套用欄位並重新辨認",
    reparseHint: "重新辨認會重設核對表中的修改及選取，其他工作表的欄位設定會保留。",
    unrecognised: "未套用到事項的原文（{{count}} 行）",
    unrecognised_one: "未套用到事項的原文（{{count}} 行）",
    unrecognised_other: "未套用到事項的原文（{{count}} 行）",
    unrecognisedHint: "包含未能辨認的內容、標題及日期格。切換工作表查看；需要的事項可加入核對表，補填日期及名稱。",
    sheetUnrecognised: "{{name}}：{{count}} 行",
    sheetUnrecognised_one: "{{name}}：{{count}} 行",
    sheetUnrecognised_other: "{{name}}：{{count}} 行",
    addToReview: "加入核對表",
    addedToReview: "已加入核對表",
    previous: "上一頁",
    next: "下一頁",
    page: "{{current}}／{{total}} 頁",
    reviewBeforeImport: "尚未匯入。請核對事項及未辨認的原文，再按確認匯入。",
    duplicateInFile: "此檔案已有相同日期及名稱的事項",
    invalidYear: "請填寫 2000 至 2100 的學年開始年份。",
    invalidHeader: "標題列行號須為 0 至 10,000 的整數。",
  },
} as const;
